import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Card from "../../Elements/Card";
import Footer, { FooterTab, MobileFooter } from "../GreenHome/Footer";
import useFindDevice from "../CustomHooks/FindDevice";
import Navbar from "../../_V2/Pages/RoundToJoin/navbar";
import { pnpLogo } from "../../_V2/Asserts";

function TermsAndConditions() {
  const navigate = useNavigate();
  const { isMob, isTab, isLaptop, isLogedIn } = useFindDevice();
  const [selectedNav, setSelectedNav] = useState("");
  const [dropdownMenuOpen, setDropdownMenuOpen] = useState(false);
  const [otherMenusOpen, setOtherMenusOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const redirectToLogin = () => {
    navigate("/login");
  };

  const redirectToRegister = () => {
    navigate("/signup");
  };

  const redirectHome = () => {
    navigate("/");
  };

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  return (
    <>
      {
        userInfo?.email && <Navbar
          setDropdownOpen={setDropdownMenuOpen}
          setSelectedNav={setSelectedNav}
          selectedNav={selectedNav}
          setMobileMenuOpen={setMobileMenuOpen}
          setDropdownPos={setDropdownPos}
          dropdownPos={dropdownPos}
          dropdownOpen={dropdownMenuOpen}
          mobileMenuOpen={mobileMenuOpen}
          setOtherMenusOpen={setOtherMenusOpen}
          otherMenusOpen={otherMenusOpen}
        />
      }


      {isMob === true ? (
        <div
          className={`font-interFont overflow-auto ${isMob
            ? "bg-[url('../public/v2/images/bg/auth-bg-mobile.png')]"
            : "bg-[url('../public/v2/images/bg/auth-bg.png')]"
            } bg-cover h-[100vh]`}
        >
          <div className="h-[100vh] mb-[50px] mobile-s:h-[750px] mobile-l:h-[850px] w-full px-2 py-5 font-Inter">
            {!userInfo?.email && (
              <div className="flex w-full p-2 justify-between items-center border-b border-[#D3D3D31F] mx-auto">
                <div className="flex-shrink-0">
                  <img 
                    src={pnpLogo} 
                    alt="pickNdPrizes" 
                    onClick={redirectHome}
                    className="h-12 w-auto cursor-pointer"
                  />
                </div>
                <div className="text-[10px] font-[400] font-roboto flex gap-1 items-center flex-shrink-0">
                  <button
                    className="bg-[#00C05B] text-[8px] py-[6px] px-[8px] rounded-[20px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToLogin}
                  >
                    Login
                  </button>

                  <button
                    className="bg-[#007FFF] text-[8px] py-[6px] px-[6px] rounded-[20px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToRegister}
                  >
                    Sign Up For Free
                  </button>
                </div>
              </div>
            )}
            <div>
              <div className={`px-2 terms-top ${userInfo?.email ? 'mt-24' : 'mt-2'}`}>
                <h2 className="text-[#FFFFFF] text-[24px] text-center">
                  Terms & Conditions
                </h2>
              </div>
              {/* <Card className="mx-2 h-[65.6vh] overflow-auto mt-5 px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <div className="text-[22px] text-[#000000] font-semibold">
                  <h4>1. Introduction</h4>
                  <h4>2. Acceptance of Terms</h4>
                  <h4>3. Account Registration & Eligibility</h4>
                  <h4>4. Entry Fees & Payments</h4>
                  <h4>5. Account Termination, Closure & Suspension</h4>
                  <h4>6. Game Entry, Announcements & Results</h4>
                  <h4>7. Syndication</h4>
                  <h4>8. Game Rules</h4>
                  <h4>9. How to Win</h4>
                  <h4>10. Responsible Gaming</h4>
                  <h4>11. Taxes</h4>
                  <h4>12. Use of Personal Information</h4>
                  <h4>13. Intellectual Property</h4>
                  <h4>14. General Conditions</h4>
                  <h4>15. Governing Law & Jurisdiction</h4>
                  <h4>16. Prize Pool & Fee Structure</h4>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  1. Introduction
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You can access the full Terms at: www.sportspik.com (the official 'website'). For any support, you may email support@sportspik.com. Operating Hours: 10 AM to 10 PM (GST), daily.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  2. Acceptance of Terms
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • These Terms
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Our Privacy Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Our Cookies Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Our Games Rules
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You have the mental capacity to be responsible for your actions and can enter into a contract.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You accept that winning is not guaranteed and tokens must be purchased to play.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms are posted on our website and are effective from 1st July 2025. We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3. Account Registration & Eligibility
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You must be at least 18 years of age to register.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You must provide accurate personal details: full name, telephone number, and email address.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • We may request age and identity verification and use third-party services for verification checks.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3.1 Sanctioned & Blocked Countries
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  4. Entry Fees & Payments
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Each token purchased consists of two parts:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  5. Account Termination, Closure & Suspension
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if you register more than one account, provide fraudulent information, enter games from restricted jurisdictions, or for maintenance purposes.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  6. Game Entry, Announcements & Results
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Announcements are made via:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Website: www.sportspik.com
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Social media: @SportsPik
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Email and push notifications
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  To enter a game, you must have an active account, purchase/redeem a minimum number of tokens required to play that round, and use token(s) to enter each round.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  7. Syndication
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. We will only be liable for any valid claim made by the registered holder of the account with the winning entry.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  8. Game Rules
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  By accepting these Terms, you agree to be bound by the SportsPik game rules.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Each round has a predetermined entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Each player can submit one or two independent picks per round. Some rounds like the high roller may be limited to one pick per player.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Each pick is assigned to a team per match week.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • A win advances the pick to the next week; a draw or a loss eliminates it.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • A team cannot be reused under the same pick until the round ends.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  8.1 Champions League
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Follows all SportsPik rules unless otherwise stated.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • First eight match weeks follow a league format; then knockout rounds begin.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Picks become limited to advancing 16 teams.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Game ends after the second leg of the quarterfinals.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  9. How to Win
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • The jackpot is won by the last remaining pick in the round.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • If all picks are eliminated in the same week, the prize is split.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  10. Responsible Gaming
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform. We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a Gaming Timeout by email at support@sportspik.com.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  11. Taxes
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Token prices include applicable taxes.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  12. Use of Personal Information
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Personal data (name, contact details, etc.) is collected for account and competition purposes.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • This data may be shared with regulatory or third-party partners.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • By registering, you consent to the use of your data as outlined in our Privacy Policy.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  13. Intellectual Property
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Content is for personal, non-commercial use only.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  14. General Conditions
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  15. Governing Law & Jurisdiction
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the Ras Al Khaimah Economic Zone (RAKEZ) and the United Arab Emirates. By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  16. Prize Pool & Fee Structure
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Each token payment made by players is divided into two components:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  a. Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT).
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  b. Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of participants, and not treated as income.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement.
                </p>

                <p className="text-[17px] mt-[2%] text-[#000000] font-semibold">
                  LAST UPDATED: 1 July 2025
                </p>
              </Card> */}
              {/* <Card className="mx-2 h-[65.6vh] overflow-auto mt-5 px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <div className="text-[22px] text-[#000000] font-semibold">
                  <h4>1. Introduction</h4>
                  <h4>2. Acceptance of Terms</h4>
                  <h4>3. Account Registration & Eligibility</h4>
                  <h4>4. Entry Fees & Payments</h4>
                  <h4>5. Account Termination, Closure & Suspension</h4>
                  <h4>6. Game Entry, Announcements & Results</h4>
                  <h4>7. Syndication</h4>
                  <h4>8. Game Rules</h4>
                  <h4>9. How to Win</h4>
                  <h4>10. Responsible Gaming</h4>
                  <h4>11. Taxes</h4>
                  <h4>12. Use of Personal Information</h4>
                  <h4>13. Intellectual Property</h4>
                  <h4>14. General Conditions</h4>
                  <h4>15. Governing Law & Jurisdiction</h4>
                  <h4>16. Prize Pool & Fee Structure</h4>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  1. INTRODUCTION
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You can access the full Terms at: www.sportspik.com (the official 'website'). For any support, you may email support@sportspik.com. Operating Hours: 10 AM to 10 PM (GST), daily.
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  We encourage all participants to play responsibly. Participation should be for entertainment purposes only. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  2. ACCEPTANCE OF TERMS
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • These Terms
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Our Privacy Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Our Cookies Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Our Games Rules
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You have the mental capacity to be responsible for your actions and can enter into a contract.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You accept that winning is not guaranteed and tokens must be purchased to play.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms are posted on our website and are effective from 1st July 2025. We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You are responsible for reviewing the Terms and Rules each time you use our platform or app. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3. ACCOUNT REGISTRATION & ELIGIBILITY  
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You must be at least 18 years of age to register.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You must provide accurate personal details: full name, telephone number, and email address.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • We may request age and identity verification and use third-party services for verification checks.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3.1 SANCTIONED & BLOCKED COUNTRIES
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
                </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • We reserve the right to block, suspend, or terminate access from such jurisdictions without notice. 
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • It is your sole responsibility to ensure that using our services is legal in your jurisdiction. We accept no liability for use in contravention of local laws. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  4. ENTRY FEES & PAYMENTS 
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Each token purchased consists of two parts:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  The administrative fee is treated as revenue. The prize pool contribution is not income and is not subject to VAT, as SportsPik acts only in a custodial or agency capacity for this portion. 
                </p>

               <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">5. ACCOUNT TERMINATION, CLOSURE & SUSPENSION</h4>

<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>5.1</strong> We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>You register more than one account at any one time;</li>
      <li>You provided information that is fraudulent, false, incomplete, or not up to date;</li>
      <li>We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
      <li>Platform or app maintenance work or upgrades are required;</li>
      <li>For any reason, we discontinue the games, or platform access;</li>
      <li>Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>5.2</strong> In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>5.3</strong> We reserve the right to take one or more of the following actions if you breach these Terms or Rules:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Terminate, vary, or suspend your account, access to the Platform, or entry into games;</li>
      <li>Take legal proceedings against you for reimbursement of any and all relevant costs on an indemnity basis resulting from your breach;</li>
      <li>Take further legal action against you, as appropriate;</li>
      <li>Disclose such information to law enforcement authorities as required or as we deem necessary; and/or</li>
      <li>Any other actions which we deem appropriate (and lawful).</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>5.4</strong> We hereby exclude any and all liability arising out of any actions (including but not limited to those set out above) that we may take in response to breaches of these Terms and Rules.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>5.5</strong> If you wish to delete your account, you may do so via “My Account.” This will permanently remove your data and forfeits any unused entries.</p>
  </li>
</ul>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">6. GAME ENTRY, ANNOUNCEMENTS, & RESULTS</h4>

<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>Announcements are made via:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Website: <a href="https://www.sportspik.com">www.sportspik.com</a></li>
      <li>Social media: @SportsPik</li>
      <li>Email and push notifications</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>To enter a game, you must:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Have an active account</li>
      <li>Purchase/Redeem a minimum number of tokens required to play that round</li>
      <li>Use token(s) to enter each round</li>
    </ul>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><em>Note: Purchased tokens are non-refundable and cannot be withdrawn. Only cash prizes are eligible for withdrawal.</em></p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>Results:</strong> Winners and results will be posted on the website and may be shared via email or on social media. Players are responsible for checking and claiming winnings in time.</p>
  </li>
</ul>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">7. SYNDICATION</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. By entering Games, you acknowledge that no representation has been made by us that we shall be responsible for or have any liability whatsoever for any purported claim from a Syndicate Member. For the avoidance of doubt, we will only be liable for any valid claim made by the registered holder of the account with the winning entry. </p>
  </li>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>7.1</strong> Where you enter with the intent of sharing a Prize with Syndicate Members, you:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Deemed to be the customer for the purposes of these Rules; and</li>
      <li>Are not acting as our agent for that purpose and we shall not be:
        <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
          <li>Liable for the payment of any Prize to any Syndicate Member other than a Prize emanating from a winning entry which is payable only to the registered holder of the Account with such winning entry; and </li>
          <li>Bound by any agreement between the registered holder of the Account and any Syndicate Member. </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">8. GAME RULES</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>By accepting these Terms, you agree to be bound by the SportsPik game rules.</li>
  <li>Each round has a set entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.</li>
  <li>Each player can submit one or two independent picks per round. Some rounds like the high roller may be limited to one pick per player.</li>
  <li>Each pick is assigned to a team per match week. </li>
  <li>A win advances the pick to the next week; a draw or a loss eliminates it.</li>
  <li>A team cannot be reused in the same pick until the round ends.</li>
  <li>If no pick is submitted before the deadline (1 hour before kickoff), a default team is assigned.</li>
  <li>One default allowed per pick per round. A second default leads to elimination.</li>
  <li>Picks are editable until the match week deadline.</li>
  <li>Postponed matches:
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Before deadline: must re-pick</li>
      <li>After deadline: treated as a win</li>
    </ul>
  </li>
  <li>For a "match week" to count or be valid in the competition, there must be at least 8 scheduled matches (fixtures) during that week. </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#0000005A] font-semibold">Disqualification:</h4>
  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>Entries are incomplete, offensive, fraudulent, or breach of laws</li>
  <li>Technical or verification checks are failed </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#0000005A] font-semibold">Game Cancellation: </h4>
  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We may cancel or suspend a game due to force majeure events like natural disasters, strikes, or health concerns. No liability is assumed. </p>


<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">8.1 CHAMPIONS LEAGUE:</p>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>Follows SportsPik rules unless otherwise noted.</li>
  <li>First 8 weeks follow league format; then knockout rounds begin.</li>
  <li>Picks are limited to remaining 16 teams during knockouts.</li>
  <li>Game ends after quarterfinals (second leg).</li>
  <li>Defaults during knockouts follow league rankings from week 8.</li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">9. HOW TO WIN</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>The jackpot is won by the last remaining pick in the round. </li>
  <li>If all picks are eliminated in the same week, the prize is split. </li>
  <li>When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.</li>
  <li>If there is no winner by the final week (last available match week), or if all the remaining players are eliminated at once, the jackpot will be equally split between those players. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">10. RESPONSIBLE GAMING</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li><strong>10.1</strong> You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform (website and mobile application). We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming. If you are struggling, we encourage you to seek help or email  <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a></li>
  <li><strong>10.2</strong> If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a Gaming Timeout by email at <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>  During this time:
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Your account will be locked and inaccessible for gameplay.</li>
      <li>No promotional will be sent.</li>
      <li>Tokens cannot be used until the timeout ends.</li>
     
    </ul>
  </li>
</ul>
 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">Once the requested period ends, your account will automatically be reactivated.</p>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">11. TAXES</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.</li>
  <li>Token prices include applicable taxes.</li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">12. USE OF PERSONAL INFORMATION</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>Personal data (name, contact details, etc.) is collected for account and competition purposes</li>
  <li>This data may be shared with regulatory or third-party partners.</li>
  <li>By registering, you consent to the use of your data as outlined in our Privacy Policy.</li>
  <li>You can access or update your information at any time. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">13. INTELLECTUAL PROPERTY</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors. </li>
  <li>Content is for personal, non-commercial use only</li>
  <li>You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">14. GENERAL CONDITIONS</h4>
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">   We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control. </p>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">15. GOVERNING LAW & JURISDICTION</h4>
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the Ras Al Khaimah Economic Zone (RAKEZ) and the United Arab Emirates. By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts. </p>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">16. PRIZE POOL & FEE STRUCTURE</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li><strong>16.1</strong> Each token payment made by players is divided into two components
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>a. Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT). </li>
      <li>b.  Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of participants, and not treated as income. </li>
    </ul>
  </li>
  <li><strong>16.2</strong> The prize pool is used strictly to fund player winnings as per the game rules. SportsPik has no discretion over its use. </li>
  <li><strong>16.3</strong> These funds are accounted for separately and not used for operating expenses. </li>
  <li><strong>16.4</strong> SportsPik acts solely as an agent concerning the prize pool and does not receive any benefit or margin from this portion. </li>
  <li><strong>16.5</strong> If a round is cancelled, the prize pool may be refunded or reallocated in line with published rules. </li>
  <li><strong>16.6</strong>Mutual Contribution Agreement: By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement. SportsPik facilitates this payout on behalf of the players.</li> 
  <li><strong>16.7</strong>Clarification of Supply: The platform fee represents the consideration for SportsPik’s service. The prize pool portion is not linked to any deliverable, benefit, or service from SportsPik and should not be considered part of the platform’s taxable supply.</li> 
</ul>
<p className="text-[20px] mt-[1%] text-[#0000005A] font-semibold">LAST UPDATED: 1 July 2025.</p>

              </Card> */}
              {/* <Card className="mx-2 h-[65.6vh] overflow-auto mt-5 px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                 <h4 className="text-[#000000] font-semibold">INDEX</h4>
                <div className="text-[22px] text-[#000000] font-semibold">
                  <h4>1. Introduction</h4>
                  <h4>2. Acceptance of Terms</h4>
                  <h4>3. Account Registration & Eligibility <br/>&nbsp;&nbsp; 3.1 Sanctioned & Blocked Countries </h4>
                  <h4>4. Entry Fees & Payments</h4>
                  <h4>5. Account Termination, Closure & Suspension</h4>
                  <h4>6. Game Entry, Announcements & Results</h4>
                  <h4>7. Syndication</h4>
                  <h4>8. Game Rules <br/>&nbsp;&nbsp; 8.1 Champions League</h4>
                  <h4>9. How to Win</h4>
                  <h4>10. Responsible Gaming</h4>
                  <h4>11. Taxes</h4>
                  <h4>12. Use of Personal Information</h4>
                  <h4>13. Intellectual Property</h4>
                  <h4>14. General Conditions</h4>
                  <h4>15. Governing Law & Jurisdiction</h4>
                  <h4>16. Prize Pool & Fee Structure</h4>
                </div>
              <div className="pt-5">
                <h2 className="text-[#000000] text-[24px] text-left font-semibold">
                  Terms & Conditions
                </h2>
              </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  1. INTRODUCTION
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You can access the full Terms at: www.sportspik.com (the official 'website'). For any support, you may email support@sportspik.com. <strong className="text-[#000000] font-semibold">Operating Hours:</strong> 10 AM to 10 PM (GST), daily.
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  We encourage all participants to play responsibly. Participation should be for entertainment purposes only. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  2. ACCEPTANCE OF TERMS
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> These Terms
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> Our Privacy Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> Our Cookies Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> Our Games Rules
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> You have the mental capacity to be responsible for your actions and can enter into a contract.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> You accept that winning is not guaranteed and tokens must be purchased to play.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms are posted on our website and are effective from <strong className="text-[#000000] font-semibold">1st July 2025.</strong> We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You are responsible for reviewing the Terms and Rules each time you use our platform or app. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3. ACCOUNT REGISTRATION & ELIGIBILITY  
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> You must be at least 18 years of age to register.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> You must provide accurate personal details: full name, telephone number, and email address.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> We may request age and identity verification and use third-party services for verification checks.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3.1 SANCTIONED & BLOCKED COUNTRIES
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
                </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> We reserve the right to block, suspend, or terminate access from such jurisdictions without notice. 
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> It is your sole responsibility to ensure that using our services is legal in your jurisdiction. We accept no liability for use in contravention of local laws. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  4. ENTRY FEES & PAYMENTS 
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4.1</strong>&nbsp;All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4.2</strong>&nbsp; Each token purchased consists of two parts:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  The administrative fee is treated as revenue. The prize pool contribution is not income and is not subject to VAT, as SportsPik acts only in a custodial or agency capacity for this portion. 
                </p>

               <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">5. ACCOUNT TERMINATION, CLOSURE & SUSPENSION</h4>

<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.1</strong> We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-6 space-y-1">
  <li className="relative pl-6 before:content-['a)'] before:absolute before:left-0 before:text-black">You register more than one account at any one time;</li>
  <li className="relative pl-6 before:content-['b)'] before:absolute before:left-0 before:text-black">You provided information that is fraudulent, false, incomplete, or not up to date;</li>
  <li className="relative pl-6 before:content-['c)'] before:absolute before:left-0 before:text-black">We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
  <li className="relative pl-6 before:content-['d)'] before:absolute before:left-0 before:text-black">Platform or app maintenance work or upgrades are required;</li>
  <li className="relative pl-6 before:content-['e)'] before:absolute before:left-0 before:text-black">For any reason, we discontinue the games, or platform access;</li>
  <li className="relative pl-6 before:content-['f)'] before:absolute before:left-0 before:text-black">Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
</ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.2</strong> In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.3</strong> We reserve the right to take one or more of the following actions if you breach these Terms or Rules:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Terminate, vary, or suspend your account, access to the Platform, or entry into games;</li>
      <li>Take legal proceedings against you for reimbursement of any and all relevant costs on an indemnity basis resulting from your breach;</li>
      <li>Take further legal action against you, as appropriate;</li>
      <li>Disclose such information to law enforcement authorities as required or as we deem necessary; and/or</li>
      <li>Any other actions which we deem appropriate (and lawful).</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.4</strong> We hereby exclude any and all liability arising out of any actions (including but not limited to those set out above) that we may take in response to breaches of these Terms and Rules.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.5</strong> If you wish to delete your account, you may do so via “My Account.” This will permanently remove your data and forfeits any unused entries.</p>
  </li>
</ul>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">6. GAME ENTRY, ANNOUNCEMENTS, & RESULTS</h4>

<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Announcements are made via:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Website: <a href="https://www.sportspik.com">www.sportspik.com</a></li>
      <li>Social media: @SportsPik</li>
      <li>Email and push notifications</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">To enter a game, you must:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Have an active account</li>
      <li>Purchase/Redeem a minimum number of tokens required to play that round</li>
      <li>Use token(s) to enter each round</li>
    </ul>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><em><strong className="text-[#000000] font-semibold">Note:</strong> Purchased tokens are non-refundable and cannot be withdrawn. Only cash prizes are eligible for withdrawal.</em></p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Results:</strong> Winners and results will be posted on the website and may be shared via email or on social media. Players are responsible for checking and claiming winnings in time.</p>
  </li>
</ul>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">7. SYNDICATION</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. By entering Games, you acknowledge that no representation has been made by us that we shall be responsible for or have any liability whatsoever for any purported claim from a Syndicate Member. For the avoidance of doubt, we will only be liable for any valid claim made by the registered holder of the account with the winning entry. </p>
  </li>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">7.1 Where you enter with the intent of sharing a Prize with Syndicate Members, you are:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li><strong className="text-[#000000] font-semibold">7.1.1</strong>&nbsp;Deemed to be the customer for the purposes of these Rules; and</li>
      <li><strong className="text-[#000000] font-semibold">7.1.2</strong>&nbsp;Are not acting as our agent for that purpose and we shall not be:
        <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
          <li>Liable for the payment of any Prize to any Syndicate Member other than a Prize emanating from a winning entry which is payable only to the registered holder of the Account with such winning entry; and </li>
          <li>Bound by any agreement between the registered holder of the Account and any Syndicate Member. </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">8. GAME RULES</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>By accepting these Terms, you agree to be bound by the SportsPik game rules.</li>
  <li>Each round has a set entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.</li>
  <li>Each player can submit <strong className="text-[#000000] font-semibold">one or two independent picks</strong> per round. Some rounds like the high roller may be limited to one pick per player.</li>
  <li><strong className="text-[#000000] font-semibold">Each pick</strong> is assigned to a team per match week. </li>
  <li>A win advances the pick to the next week; a draw or a loss eliminates it.</li>
  <li>A team cannot be reused in the same pick until the round ends.</li>
  <li>If no pick is submitted before the deadline (1 hour before kickoff), a default team is assigned.</li>
  <li>One default allowed per pick per round. A second default leads to elimination.</li>
  <li>Picks are editable until the match week deadline.</li>
  <li>Postponed matches:
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5 space-y-1">
  <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
    Before deadline: must re-pick
  </li>
  <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
    After deadline: treated as a win
  </li>
</ul>
  </li>
  <li>For a "match week" to count or be valid in the competition, there must be <strong className="text-[#000000] font-semibold">at least 8 scheduled matches</strong> (fixtures) during that week. </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Disqualification:</h4>
  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Entries are incomplete, offensive, fraudulent, or breach of laws</li>
  <li>Technical or verification checks are failed </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Game Cancellation: </h4>
  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We may cancel or suspend a game due to force majeure events like natural disasters, strikes, or health concerns. No liability is assumed. </p>


<p className="text-[17px] mt-[1%] text-[#000000] font-semibold">8.1 CHAMPIONS LEAGUE:</p>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Follows SportsPik rules unless otherwise noted.</li>
  <li>First eight match weeks follow league format; then knockout rounds begin.</li>
  <li>Picks become limited to advancing 16 teams.</li>
  <li>Game ends after the second leg of the quarterfinals.</li>
  <li>Defaults during knockouts follow league ranking from week 8.</li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">9. HOW TO WIN</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>The jackpot is won by the last remaining pick in the round. </li>
  <li>If all picks are eliminated in the same week, the prize is split. </li>
  <li>When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.</li>
  <li>If there is no winner by the final week (last available match week), or if all the remaining players are eliminated at once, the jackpot will be equally split between those players. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">10. RESPONSIBLE GAMING</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li><strong className="text-[#000000] font-semibold">10.1</strong> You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform (website and mobile application). We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming. If you are struggling, we encourage you to seek help or email  <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a></li>
  <li><strong className="text-[#000000] font-semibold">10.2</strong> If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a <strong className="text-[#000000] font-semibold">Gaming Timeout</strong> by email at <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>  <strong className="text-[#000000] font-semibold">During this time:</strong>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Your account will be locked and inaccessible for gameplay.</li>
      <li>No promotional will be sent.</li>
      <li>Tokens cannot be used until the timeout ends.</li>
     
    </ul>
  </li>
</ul>
 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">Once the requested period ends, your account will automatically be reactivated.</p>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">11. TAXES</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.</li>
  <li>Token prices include applicable taxes.</li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">12. USE OF PERSONAL INFORMATION</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Personal data (name, contact details, etc.) is collected for account and competition purposes.</li>
  <li>This data may be shared with regulatory or third-party partners.</li>
  <li>By registering, you consent to the use of your data as outlined in our Privacy Policy.</li>
  <li>You can access or update your information at any time. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">13. INTELLECTUAL PROPERTY</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors. </li>
  <li>Content is for personal, non-commercial use only.</li>
  <li>You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">14. GENERAL CONDITIONS</h4>
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">   We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control. </p>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">15. GOVERNING LAW & JURISDICTION</h4>
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the  <strong className="text-[#000000] font-semibold">Ras Al Khaimah Economic Zone (RAKEZ)</strong> and the <strong className="text-[#000000] font-semibold">United Arab Emirates.</strong> By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts. </p>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">16. PRIZE POOL & FEE STRUCTURE</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
  <li><strong className="text-[#000000] font-semibold">16.1</strong> Each token payment made by players is divided into two components:
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
      <li>a. Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT). </li>
      <li>b.  Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of <strong className="text-[#000000] font-semibold">participants, and not treated as income.</strong> </li>
    </ul>
  </li>
  <li><strong className="text-[#000000] font-semibold">16.2</strong> The prize pool is used strictly to fund player winnings as per the game rules. SportsPik has no discretion over its use. </li>
  <li><strong className="text-[#000000] font-semibold">16.3</strong> These funds are accounted for separately and not used for operating expenses. </li>
  <li><strong className="text-[#000000] font-semibold">16.4</strong> SportsPik acts solely as an agent concerning the prize pool and does not receive any benefit or margin from this portion. </li>
  <li><strong className="text-[#000000] font-semibold">16.5</strong> If a round is cancelled, the prize pool may be refunded or reallocated in line with published rules. </li>
  <li><strong className="text-[#000000] font-semibold">16.6</strong> Mutual Contribution Agreement: By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement. SportsPik facilitates this payout on behalf of the players.</li>
 <li><strong className="text-[#000000] font-semibold">16.7</strong> Clarification of Supply: The platform fee represents the consideration for SportsPik’s service. The prize pool portion is not linked to any deliverable, benefit, or service from SportsPik and should not be considered part of the platform’s taxable supply.</li>
</ul>
<p className="text-[20px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">LAST UPDATED: 1 July 2025.</strong></p>
              </Card> */}
              {/* <Card className="mx-2 h-[65.6vh] overflow-auto mt-5 px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                 <h4 className="text-[22px] text-[#000000] font-semibold">INDEX</h4>
               
                <div className="text-[22px] text-[#000000] font-semibold space-y-2 pt-6">
  <h4 className="flex gap-2"><span className="w-6">1.</span> <span>Introduction</span></h4>
  <h4 className="flex gap-2"><span className="w-6">2.</span> <span>Acceptance of Terms</span></h4>
  <h4 className="flex flex-col gap-1">
    <div className="flex gap-2"><span className="w-6">3.</span> <span>Account Registration & Eligibility</span></div>
    <div className="pl-8">3.1 Sanctioned & Blocked Countries</div>
  </h4>
  <h4 className="flex gap-2"><span className="w-6">4.</span> <span>Entry Fees & Payments</span></h4>
  <h4 className="flex gap-2"><span className="w-6">5.</span> <span>Account Termination, Closure & Suspension</span></h4>
  <h4 className="flex gap-2"><span className="w-6">6.</span> <span>Game Entry, Announcements & Results</span></h4>
  <h4 className="flex gap-2"><span className="w-6">7.</span> <span>Syndication</span></h4>
  <h4 className="flex flex-col gap-1">
    <div className="flex gap-2"><span className="w-6">8.</span> <span>Game Rules</span></div>
    <div className="pl-8">8.1 Champions League</div>
  </h4>
  <h4 className="flex gap-2"><span className="w-6">9.</span> <span>How to Win</span></h4>
  <h4 className="flex gap-2"><span className="w-6">10.</span> <span>Responsible Gaming</span></h4>
  <h4 className="flex gap-2"><span className="w-6">11.</span> <span>Taxes</span></h4>
  <h4 className="flex gap-2"><span className="w-6">12.</span> <span>Use of Personal Information</span></h4>
  <h4 className="flex gap-2"><span className="w-6">13.</span> <span>Intellectual Property</span></h4>
  <h4 className="flex gap-2"><span className="w-6">14.</span> <span>General Conditions</span></h4>
  <h4 className="flex gap-2"><span className="w-6">15.</span> <span>Governing Law & Jurisdiction</span></h4>
  <h4 className="flex gap-2"><span className="w-6">16.</span> <span>Prize Pool & Fee Structure</span></h4>
</div>

              <div className="pt-16">
                <h2 className="text-[#000000] text-[24px] text-left font-semibold">
                  Terms & Conditions
                </h2>
              </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  1. INTRODUCTION
                </h4>
                <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You can access the full Terms at: <span className="underline text-[#0000005A]"> www.sportspik.com</span> (the official 'website'). For any support, you may email <span className="underline text-[#0000005A]"> support@sportspik.com</span>. <strong className="text-[#000000] font-semibold">Operating Hours:</strong> 10 AM to 10 PM (GST), daily.
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  We encourage all participants to play responsibly. Participation should be for entertainment purposes only. 
                </p>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  2. ACCEPTANCE OF TERMS
                </h4>
                <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> These Terms
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Privacy Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Cookies Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Games Rules
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> You have the mental capacity to be responsible for your actions and can enter into a contract.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> You accept that winning is not guaranteed and tokens must be purchased to play.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms are posted on our website and are effective from <strong className="text-[#000000] font-semibold">1st July 2025.</strong> We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You are responsible for reviewing the Terms and Rules each time you use our platform or app. 
                </p>
                  </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3. ACCOUNT REGISTRATION & ELIGIBILITY  
                </h4>
                <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You must be at least 18 years of age to register.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You must provide accurate personal details: full name, telephone number, and email address.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> We may request age and identity verification and use third-party services for verification checks.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
                </p>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3.1 SANCTIONED & BLOCKED COUNTRIES
                </h4>
                <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
                </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> We reserve the right to block, suspend, or terminate access from such jurisdictions without notice. 
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> It is your sole responsibility to ensure that using our services is legal in your jurisdiction. We accept no liability for use in contravention of local laws. 
                </p>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  4. ENTRY FEES & PAYMENTS 
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4.1</strong>&nbsp;&nbsp;All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4.2</strong>&nbsp;&nbsp;Each token purchased consists of two parts:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-10">
                  <strong className="text-[#000000] font-semibold">•</strong> An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-10">
                  <strong className="text-[#000000] font-semibold">•</strong> A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold  pl-7">
                  The administrative fee is treated as revenue. The prize pool contribution is not income and is not subject to VAT, as SportsPik acts only in a custodial or agency capacity for this portion. 
                </p>

               <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">5. ACCOUNT TERMINATION, CLOSURE & SUSPENSION</h4>
<div className="pl-6">
<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold pr-2">5.1</strong> We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if:</p>
   
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-6 space-y-1">
  <li className="relative pl-6 before:content-['a)'] before:absolute before:left-0 before:text-black">You register more than one account at any one time;</li>
  <li className="relative pl-6 before:content-['b)'] before:absolute before:left-0 before:text-black">You provided information that is fraudulent, false, incomplete, or not up to date;</li>
  <li className="relative pl-6 before:content-['c)'] before:absolute before:left-0 before:text-black">We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
  <li className="relative pl-6 before:content-['d)'] before:absolute before:left-0 before:text-black">Platform or app maintenance work or upgrades are required;</li>
  <li className="relative pl-6 before:content-['e)'] before:absolute before:left-0 before:text-black">For any reason, we discontinue the games, or platform access;</li>
  <li className="relative pl-6 before:content-['f)'] before:absolute before:left-0 before:text-black">Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
</ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.2</strong> In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.3</strong> We reserve the right to take one or more of the following actions if you breach these Terms or Rules:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Terminate, vary, or suspend your account, access to the Platform, or entry into games;</li>
      <li>Take legal proceedings against you for reimbursement of any and all relevant costs on an indemnity basis resulting from your breach;</li>
      <li>Take further legal action against you, as appropriate;</li>
      <li>Disclose such information to law enforcement authorities as required or as we deem necessary; and/or</li>
      <li>Any other actions which we deem appropriate (and lawful).</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.4</strong> We hereby exclude any and all liability arising out of any actions (including but not limited to those set out above) that we may take in response to breaches of these Terms and Rules.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.5</strong> If you wish to delete your account, you may do so via “My Account.” This will permanently remove your data and forfeits any unused entries.</p>
  </li>
</ul>
</div>
<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">6. GAME ENTRY, ANNOUNCEMENTS, & RESULTS</h4>
<div className="pl-6">
<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Announcements are made via:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Website: <a href="https://www.sportspik.com" class="underline">www.sportspik.com</a></li>
      <li>Social media: @SportsPik</li>
      <li>Email and push notifications</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">To enter a game, you must:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Have an active account</li>
      <li>Purchase/Redeem a minimum number of tokens required to play that round</li>
      <li>Use token(s) to enter each round</li>
    </ul>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><em><strong className="text-[#000000] font-semibold">Note:</strong> Purchased tokens are non-refundable and cannot be withdrawn. Only cash prizes are eligible for withdrawal.</em></p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Results:</strong> Winners and results will be posted on the website and may be shared via email or on social media. Players are responsible for checking and claiming winnings in time.</p>
  </li>
</ul>
</div>
<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">7. SYNDICATION</h4>
<ul className="text-[17px]  text-[#0000005A] font-semibold  pl-5">
  <li>
    <p className="text-[17px] pl-4 text-[#0000005A] font-semibold">We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. By entering Games, you acknowledge that no representation has been made by us that we shall be responsible for or have any liability whatsoever for any purported claim from a Syndicate Member. For the avoidance of doubt, we will only be liable for any valid claim made by the registered holder of the account with the winning entry. </p>
  </li>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">7.1 Where you enter with the intent of sharing a Prize with Syndicate Members, you are:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
      <li><strong className="text-[#000000] font-semibold pr-1">7.1.1</strong>&nbsp;Deemed to be the customer for the purposes of these Rules; and</li>
      <li><strong className="text-[#000000] font-semibold pr-1">7.1.2</strong>&nbsp;Are not acting as our agent for that purpose and we shall not be:
        <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
          <li>Liable for the payment of any Prize to any Syndicate Member other than a Prize emanating from a winning entry which is payable only to the registered holder of the Account with such winning entry; and </li>
          <li>Bound by any agreement between the registered holder of the Account and any Syndicate Member. </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">8. GAME RULES</h4>
 <p className="text-[17px] pl-7 text-[#0000005A] font-semibold">By accepting these Terms, you agree to be bound by the SportsPik game rules.</p>
<div className="pl-8">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
 
  <li>Each round has a predetermined entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.</li>
  <li>Each player can submit <strong className="text-[#000000] font-semibold">one or two independent picks</strong> per round. Some rounds like the high roller may be limited to one pick per player.</li>
  <li><strong className="text-[#000000] font-semibold">Each pick</strong> is assigned to a team per match week. </li>
  <li>A win advances the pick to the next week; a draw or a loss eliminates it.</li>
  <li>A team cannot be reused under the same pick until the round ends</li>
   <li>If no pick is submitted by the advertised deadline (1 hour before the first match), a default team is assigned. </li>
  <li>One default is allowed per pick per round; a second results in elimination.</li>
  <li>Picks can be edited until the match week deadline.</li>
  <li>Postponed matches:
    
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5 space-y-1">
  <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
    Before deadline: must re-pick
  </li>
  <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
    After deadline: treated as a win
  </li>
</ul>
  </li>
  <li>For a "match week" to count or be valid in the competition, there must be <strong className="text-[#000000] font-semibold">at least 8 scheduled matches</strong> (fixtures) during that week. </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Disqualification:</h4>
  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Entries are incomplete, offensive, fraudulent, or breach of laws</li>
  <li>Technical or verification checks are failed </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Game Cancellation: </h4>
  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We may cancel or suspend a game due to force majeure events like natural disasters, strikes, or health concerns. No liability is assumed. </p>


<p className="text-[17px] mt-[1%] text-[#000000] font-semibold">8.1 CHAMPIONS LEAGUE:</p>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Follows all SportsPik rules unless otherwise stated.</li>
  <li>First eight match weeks follow a league format; then knockout rounds begin.</li>
  <li>Picks become limited to advancing 16 teams.</li>
  <li>Game ends after the second leg of the quarterfinals.</li>
  <li>Defaults during knockouts follow league ranking from week 8.</li>
</ul>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">9. HOW TO WIN</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>The jackpot is won by the last remaining pick in the round. </li>
  <li>If all picks are eliminated in the same week, the prize is split. </li>
  <li>When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.</li>
  <li>If there is no winner by the final week (last available match week), or if all the remaining players are eliminated at once, the jackpot will be equally split between those players. </li>
</ul>
</div>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">10. RESPONSIBLE GAMING</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
  <li><strong className="text-[#000000] font-semibold">10.1</strong> You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform (website and mobile application). We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming. If you are struggling, we encourage you to seek help or email  <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a></li>
  <li><strong className="text-[#000000] font-semibold">10.2</strong> If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a <strong className="text-[#000000] font-semibold">Gaming Timeout</strong> by email at <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>  <strong className="text-[#000000] font-semibold">During this time:</strong>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Your account will be locked and inaccessible for gameplay.</li>
      <li>No promotional will be sent.</li>
      <li>Tokens cannot be used until the timeout ends.</li>
     
    </ul>
  </li>
</ul>
 <p className="text-[17px] mt-[1%] text-[#0000005A] pl-5 font-semibold">Once the requested period ends, your account will automatically be reactivated.</p>
</div>
<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">11. TAXES</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.</li>
  <li>Token prices include applicable taxes.</li>
</ul>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">12. USE OF PERSONAL INFORMATION</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Personal data (name, contact details, etc.) is collected for account and competition purposes.</li>
  <li>This data may be shared with regulatory or third-party partners.</li>
  <li>By registering, you consent to the use of your data as outlined in our Privacy Policy.</li>
  <li>You can access or update your information at any time. </li>
</ul>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">13. INTELLECTUAL PROPERTY</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors. </li>
  <li>Content is for personal, non-commercial use only.</li>
  <li>You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners. </li>
</ul>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">14. GENERAL CONDITIONS</h4>
<div className="pl-6">
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">   We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control. </p>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">15. GOVERNING LAW & JURISDICTION</h4>
<div className="pl-6">
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the  <strong className="text-[#000000] font-semibold">Ras Al Khaimah Economic Zone (RAKEZ)</strong> and the <strong className="text-[#000000] font-semibold">United Arab Emirates.</strong> By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts. </p>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">16. PRIZE POOL & FEE STRUCTURE</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
  <li><strong className="text-[#000000] font-semibold ">16.1</strong> Each token payment made by players is divided into two components:
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
      <li>a. Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT). </li>
      <li>b.  Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of <strong className="text-[#000000] font-semibold">participants, and not treated as income.</strong> </li>
    </ul>
  </li>
  <li><strong className="text-[#000000] font-semibold pr-1">16.2</strong>The prize pool is used strictly to fund player winnings as per the game rules. SportsPik has no discretion over its use. </li>
  <li><strong className="text-[#000000] font-semibold pr-1">16.3</strong>These funds are accounted for separately and not used for operating expenses. </li>
  <li><strong className="text-[#000000] font-semibold pr-1">16.4</strong>SportsPik acts solely as an agent concerning the prize pool and does not receive any benefit or margin from this portion. </li>
  <li><strong className="text-[#000000] font-semibold pr-1">16.5</strong>If a round is cancelled, the prize pool may be refunded or reallocated in line with published rules. </li>
  <li><strong className="text-[#000000] font-semibold pr-1">16.6</strong>Mutual Contribution Agreement: By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement. SportsPik facilitates this payout on behalf of the players.</li>
 <li><strong className="text-[#000000] font-semibold pr-1">16.7</strong>Clarification of Supply: The platform fee represents the consideration for SportsPik’s service. The prize pool portion is not linked to any deliverable, benefit, or service from SportsPik and should not be considered part of the platform’s taxable supply.</li>
</ul>
</div>
<p className="text-[20px] mt-[3%] text-[#0000005A] font-semibold italic"><strong className="text-[#000000] font-semibold">LAST UPDATED: 1 July 2025.</strong></p>
   
              </Card> */}
              <Card className="mx-2 h-[65.6vh] overflow-auto mt-12 sm:mt-5 px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <h4 className="md:text-[22px] text-[#000000] font-semibold">INDEX</h4>
                {/* <div className="text-[22px] text-[#000000] font-semibold">
                  <h4>1. Introduction</h4>
                  <h4>2. Acceptance of Terms</h4>
                  <h4>3. Account Registration & Eligibility <br/>&nbsp;&nbsp; 3.1 Sanctioned & Blocked Countries </h4>
                  <h4>4. Entry Fees & Payments</h4>
                  <h4>5. Account Termination, Closure & Suspension</h4>
                  <h4>6. Game Entry, Announcements & Results</h4>
                  <h4>7. Syndication</h4>
                  <h4>8. Game Rules <br/>&nbsp;&nbsp; 8.1 Champions League</h4>
                  <h4>9. How to Win</h4>
                  <h4>10. Responsible Gaming</h4>
                  <h4>11. Taxes</h4>
                  <h4>12. Use of Personal Information</h4>
                  <h4>13. Intellectual Property</h4>
                  <h4>14. General Conditions</h4>
                  <h4>15. Governing Law & Jurisdiction</h4>
                  <h4>16. Prize Pool & Fee Structure</h4>
                </div> */}
                {/* <div className="text-[19px] text-[#000000] font-semibold space-y-2 pt-6">
  <h4 className="flex gap-2"><span className="w-7">1.</span> <span>Introduction</span></h4>
  <h4 className="flex gap-2"><span className="w-7">2.</span> <span>Acceptance of Terms</span></h4>
  <h4 className="flex flex-col gap-1">
    <div className="flex gap-2"><span className="w-7">3.</span> <span>Account Registration & Eligibility</span></div>
    <div className="pl-9">3.1 Sanctioned & Blocked Countries</div>
  </h4>
  <h4 className="flex gap-2"><span className="w-7">4.</span> <span>Entry Fees & Payments</span></h4>
  <h4 className="flex gap-2"><span className="w-7">5.</span> <span>Account Termination, Closure & Suspension</span></h4>
  <h4 className="flex gap-2"><span className="w-7">6.</span> <span>Game Entry, Announcements & Results</span></h4>
  <h4 className="flex gap-2"><span className="w-7">7.</span> <span>Syndication</span></h4>
  <h4 className="flex flex-col gap-1">
    <div className="flex gap-2"><span className="w-7">8.</span> <span>Game Rules</span></div>
    <div className="pl-9">8.1 Champions League</div>
  </h4>
  <h4 className="flex gap-2"><span className="w-7">9.</span> <span>How to Win</span></h4>
  <h4 className="flex gap-2"><span className="w-7">10.</span> <span>Responsible Gaming</span></h4>
  <h4 className="flex gap-2"><span className="w-7">11.</span> <span>Taxes</span></h4>
  <h4 className="flex gap-2"><span className="w-7">12.</span> <span>Use of Personal Information</span></h4>
  <h4 className="flex gap-2"><span className="w-7">13.</span> <span>Intellectual Property</span></h4>
  <h4 className="flex gap-2"><span className="w-7">14.</span> <span>General Conditions</span></h4>
  <h4 className="flex gap-2"><span className="w-7">15.</span> <span>Governing Law & Jurisdiction</span></h4>
  <h4 className="flex gap-2"><span className="w-7">16.</span> <span>Prize Pool & Fee Structure</span></h4>
</div> */}
                <div className="md:text-[19px] text-[#000000] font-semibold pt-6 space-y-2">
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>1.</span> <span>Introduction</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>2.</span> <span>Acceptance of Terms</span>
                  </div>
                  <div className="space-y-1">
                    <div className="grid grid-cols-[2rem_1fr] gap-2">
                      <span>3.</span> <span>Account Registration & Eligibility</span>
                    </div>
                    <div className="grid grid-cols-[2rem_1fr] gap-2 pl-1">
                      <span></span> <span>3.1 Sanctioned & Blocked Countries</span>
                    </div>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>4.</span> <span>Entry Fees & Payments</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>5.</span> <span>Account Termination, Closure & Suspension</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>6.</span> <span>Game Entry, Announcements & Results</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>7.</span> <span>Syndication</span>
                  </div>
                  <div className="space-y-1">
                    <div className="grid grid-cols-[2rem_1fr] gap-2">
                      <span>8.</span> <span>Game Rules</span>
                    </div>
                    <div className="grid grid-cols-[2rem_1fr] gap-2 pl-1">
                      <span></span> <span>8.1 Champions League</span>
                    </div>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>9.</span> <span>How to Win</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>10.</span> <span>Responsible Gaming</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>11.</span> <span>Taxes</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>12.</span> <span>Use of Personal Information</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>13.</span> <span>Intellectual Property</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>14.</span> <span>General Conditions</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>15.</span> <span>Governing Law & Jurisdiction</span>
                  </div>
                  <div className="grid grid-cols-[2rem_1fr] gap-2">
                    <span>16.</span> <span>Prize Pool & Fee Structure</span>
                  </div>
                </div>


                <div className="pt-16">
                  <h2 className="text-[#000000] md:text-[24px] text-left font-semibold">
                    Terms & Conditions
                  </h2>
                </div>
                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">
                  1. INTRODUCTION
                </h4>
                <div className="pl-6">
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    You can access the full Terms at: <span className="underline text-[#0000005A]"> www.sportspik.com</span> (the official 'website'). For any support, you may email <span className="underline text-[#0000005A]"> support@sportspik.com</span>. <strong className="text-[#000000] font-semibold">Operating Hours:</strong> 10 AM to 10 PM (GST), daily.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    We encourage all participants to play responsibly. Participation should be for entertainment purposes only.
                  </p>
                </div>

                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">
                  2. ACCEPTANCE OF TERMS
                </h4>
                <div className="pl-6">
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> These Terms
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Privacy Policy
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Cookies Policy
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Games Rules
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You have the mental capacity to be responsible for your actions and can enter into a contract.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You accept that winning is not guaranteed and tokens must be purchased to play.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    These Terms are posted on our website and are effective from <strong className="text-[#000000] font-semibold">1st July 2025.</strong> We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    You are responsible for reviewing the Terms and Rules each time you use our platform or app.
                  </p>
                </div>
                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3. ACCOUNT REGISTRATION & ELIGIBILITY
                </h4>
                <div className="pl-6">
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You must be at least 18 years of age to register.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You must provide accurate personal details: full name, telephone number, and email address.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> We may request age and identity verification and use third-party services for verification checks.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
                  </p>
                </div>
                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3.1 SANCTIONED & BLOCKED COUNTRIES
                </h4>
                <div className="pl-6">
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> We reserve the right to block, suspend, or terminate access from such jurisdictions without notice.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> It is your sole responsibility to ensure that using our services is legal in your jurisdiction. We accept no liability for use in contravention of local laws.
                  </p>
                </div>
                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">
                  4. ENTRY FEES & PAYMENTS
                </h4>
                <div className="pl-6">
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold">4.1</strong>&nbsp;&nbsp;All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold">4.2</strong>&nbsp;&nbsp;Each token purchased consists of two parts:
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-10">
                    <strong className="text-[#000000] font-semibold">•</strong> An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-10">
                    <strong className="text-[#000000] font-semibold">•</strong> A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
                  </p>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold ">
                    The administrative fee is treated as revenue. The prize pool contribution is not income and is not subject to VAT, as SportsPik acts only in a custodial or agency capacity for this portion.
                  </p>
                </div>
                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">5. ACCOUNT TERMINATION, CLOSURE & SUSPENSION</h4>
                <div className="pl-6">
                  <ul>
                    <li>
                      <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold pr-2">5.1</strong> We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if:</p>
                      {/* <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>You register more than one account at any one time;</li>
      <li>You provided information that is fraudulent, false, incomplete, or not up to date;</li>
      <li>We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
      <li>Platform or app maintenance work or upgrades are required;</li>
      <li>For any reason, we discontinue the games, or platform access;</li>
      <li>Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
    </ul> */}
                      <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-6 space-y-1">
                        <li className="relative pl-6 before:content-['a)'] before:absolute before:left-0 before:text-black">You register more than one account at any one time;</li>
                        <li className="relative pl-6 before:content-['b)'] before:absolute before:left-0 before:text-black">You provided information that is fraudulent, false, incomplete, or not up to date;</li>
                        <li className="relative pl-6 before:content-['c)'] before:absolute before:left-0 before:text-black">We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
                        <li className="relative pl-6 before:content-['d)'] before:absolute before:left-0 before:text-black">Platform or app maintenance work or upgrades are required;</li>
                        <li className="relative pl-6 before:content-['e)'] before:absolute before:left-0 before:text-black">For any reason, we discontinue the games, or platform access;</li>
                        <li className="relative pl-6 before:content-['f)'] before:absolute before:left-0 before:text-black">Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
                      </ul>
                    </li>

                    <li>
                      <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.2</strong> In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.</p>
                    </li>

                    <li>
                      <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.3</strong> We reserve the right to take one or more of the following actions if you breach these Terms or Rules:</p>
                      <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                        <li>Terminate, vary, or suspend your account, access to the Platform, or entry into games;</li>
                        <li>Take legal proceedings against you for reimbursement of any and all relevant costs on an indemnity basis resulting from your breach;</li>
                        <li>Take further legal action against you, as appropriate;</li>
                        <li>Disclose such information to law enforcement authorities as required or as we deem necessary; and/or</li>
                        <li>Any other actions which we deem appropriate (and lawful).</li>
                      </ul>
                    </li>

                    <li>
                      <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.4</strong> We hereby exclude any and all liability arising out of any actions (including but not limited to those set out above) that we may take in response to breaches of these Terms and Rules.</p>
                    </li>

                    <li>
                      <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.5</strong> If you wish to delete your account, you may do so via “My Account.” This will permanently remove your data and forfeits any unused entries.</p>
                    </li>
                  </ul>
                </div>
                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">6. GAME ENTRY, ANNOUNCEMENTS, & RESULTS</h4>
                <div className="pl-6">
                  <ul>
                    <li>
                      <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Announcements are made via:</strong></p>
                      <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                        <li>Website: <a href="https://www.sportspik.com" class="underline">www.sportspik.com</a></li>
                        <li>Social media: @SportsPik</li>
                        <li>Email and push notifications</li>
                      </ul>
                    </li>

                    <li>
                      <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">To enter a game, you must:</strong></p>
                      <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                        <li>Have an active account</li>
                        <li>Purchase/Redeem a minimum number of tokens required to play that round</li>
                        <li>Use token(s) to enter each round</li>
                      </ul>
                      <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold"><em><strong className="text-[#000000] font-semibold">Note:</strong> Purchased tokens are non-refundable and cannot be withdrawn. Only cash prizes are eligible for withdrawal.</em></p>
                    </li>

                    <li>
                      <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Results:</strong> Winners and results will be posted on the website and may be shared via email or on social media. Players are responsible for checking and claiming winnings in time.</p>
                    </li>
                  </ul>
                </div>
                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">7. SYNDICATION</h4>
                <ul className="md:text-[17px]  text-[#0000005A] font-semibold  pl-5">
                  <li>
                    <p className="md:text-[17px] text-[#0000005A] font-semibold">We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. By entering Games, you acknowledge that no representation has been made by us that we shall be responsible for or have any liability whatsoever for any purported claim from a Syndicate Member. For the avoidance of doubt, we will only be liable for any valid claim made by the registered holder of the account with the winning entry. </p>
                  </li>
                  <li>
                    <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">7.1 Where you enter with the intent of sharing a Prize with Syndicate Members, you are:</strong></p>
                    <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                      <li><strong className="text-[#000000] font-semibold pr-1">7.1.1</strong>&nbsp;Deemed to be the customer for the purposes of these Rules; and</li>
                      <li><strong className="text-[#000000] font-semibold pr-1">7.1.2</strong>&nbsp;Are not acting as our agent for that purpose and we shall not be:
                        <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                          <li>Liable for the payment of any Prize to any Syndicate Member other than a Prize emanating from a winning entry which is payable only to the registered holder of the Account with such winning entry; and </li>
                          <li>Bound by any agreement between the registered holder of the Account and any Syndicate Member. </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>


                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">8. GAME RULES</h4>
                <p className="md:text-[17px] pl-7 text-[#0000005A] font-semibold">By accepting these Terms, you agree to be bound by the SportsPik game rules.</p>
                <div className="pl-8">
                  <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    {/* <li>By accepting these Terms, you agree to be bound by the SportsPik game rules.</li> */}
                    <li>Each round has a predetermined entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.</li>
                    <li>Each player can submit <strong className="text-[#000000] font-semibold">one or two independent picks</strong> per round. Some rounds like the high roller may be limited to one pick per player.</li>
                    <li><strong className="text-[#000000] font-semibold">Each pick</strong> is assigned to a team per match week. </li>
                    <li>A win advances the pick to the next week; a draw or a loss eliminates it.</li>
                    <li>A team cannot be reused under the same pick until the round ends</li>
                    <li>If no pick is submitted by the advertised deadline (1 hour before the first match), a default team is assigned. </li>
                    <li>One default is allowed per pick per round; a second results in elimination.</li>
                    <li>Picks can be edited until the match week deadline.</li>
                    <li>Postponed matches:
                      {/* <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Before deadline: must re-pick</li>
      <li>After deadline: treated as a win</li>
    </ul> */}
                      <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5 space-y-1">
                        <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
                          Before deadline: must re-pick
                        </li>
                        <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
                          After deadline: treated as a win
                        </li>
                      </ul>
                    </li>
                    <li>For a "match week" to count or be valid in the competition, there must be <strong className="text-[#000000] font-semibold">at least 8 scheduled matches</strong> (fixtures) during that week. </li>
                  </ul>
                  <h4 className="md:text-[16px] mt-[2%] text-[#000000] font-semibold">Disqualification:</h4>
                  <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>Entries are incomplete, offensive, fraudulent, or breach of laws</li>
                    <li>Technical or verification checks are failed </li>
                  </ul>
                  <h4 className="md:text-[16px] mt-[2%] text-[#000000] font-semibold">Game Cancellation: </h4>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We may cancel or suspend a game due to force majeure events like natural disasters, strikes, or health concerns. No liability is assumed. </p>


                  <p className="md:text-[17px] mt-[1%] text-[#000000] font-semibold">8.1 CHAMPIONS LEAGUE:</p>
                  <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>Follows all SportsPik rules unless otherwise stated.</li>
                    <li>First eight match weeks follow a league format; then knockout rounds begin.</li>
                    <li>Picks become limited to advancing 16 teams.</li>
                    <li>Game ends after the second leg of the quarterfinals.</li>
                    <li>Defaults during knockouts follow league ranking from week 8.</li>
                  </ul>
                </div>

                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">9. HOW TO WIN</h4>
                <div className="pl-6">
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>The jackpot is won by the last remaining pick in the round. </li>
                    <li>If all picks are eliminated in the same week, the prize is split. </li>
                    <li>When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.</li>
                    <li>If there is no winner by the final week (last available match week), or if all the remaining players are eliminated at once, the jackpot will be equally split between those players. </li>
                  </ul>
                </div>


                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">10. RESPONSIBLE GAMING</h4>
                <div className="pl-6">
                  <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-3">
                    <li><strong className="text-[#000000] font-semibold">10.1</strong> You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform (website and mobile application). We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming. If you are struggling, we encourage you to seek help or email  <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a></li>
                    <li><strong className="text-[#000000] font-semibold">10.2</strong> If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a <strong className="text-[#000000] font-semibold">Gaming Timeout</strong> by email at <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>  <strong className="text-[#000000] font-semibold">During this time:</strong>
                      <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                        <li>Your account will be locked and inaccessible for gameplay.</li>
                        <li>No promotional will be sent.</li>
                        <li>Tokens cannot be used until the timeout ends.</li>

                      </ul>
                    </li>
                  </ul>
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] pl-5 font-semibold">Once the requested period ends, your account will automatically be reactivated.</p>
                </div>
                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">11. TAXES</h4>
                <div className="pl-8">
                  <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.</li>
                    <li>Token prices include applicable taxes.</li>
                  </ul>
                </div>

                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">12. USE OF PERSONAL INFORMATION</h4>
                <div className="pl-9">
                  <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>Personal data (name, contact details, etc.) is collected for account and competition purposes.</li>
                    <li>This data may be shared with regulatory or third-party partners.</li>
                    <li>By registering, you consent to the use of your data as outlined in our Privacy Policy.</li>
                    <li>You can access or update your information at any time. </li>
                  </ul>
                </div>

                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">13. INTELLECTUAL PROPERTY</h4>
                <div className="pl-9">
                  <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors. </li>
                    <li>Content is for personal, non-commercial use only.</li>
                    <li>You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners. </li>
                  </ul>
                </div>

                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">14. GENERAL CONDITIONS</h4>
                <div className="pl-9">
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">   We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control. </p>
                </div>

                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">15. GOVERNING LAW & JURISDICTION</h4>
                <div className="pl-9">
                  <p className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold">These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the  <strong className="text-[#000000] font-semibold">Ras Al Khaimah Economic Zone (RAKEZ)</strong> and the <strong className="text-[#000000] font-semibold">United Arab Emirates.</strong> By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts. </p>
                </div>

                <h4 className="md:text-[22px] mt-[2%] text-[#000000] font-semibold">16. PRIZE POOL & FEE STRUCTURE</h4>
                <div className="pl-6">
                  <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-3">
                    <li><strong className="text-[#000000] font-semibold ">16.1</strong> Each token payment made by players is divided into two components:
                      <ul className="md:text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
                        <li><strong className="text-[#000000] font-semibold ">a.</strong> Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT). </li>
                        <li><strong className="text-[#000000] font-semibold ">b.</strong>  Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of <strong className="text-[#000000] font-semibold">participants, and not treated as income.</strong> </li>
                      </ul>
                    </li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.2</strong>The prize pool is used strictly to fund player winnings as per the game rules. SportsPik has no discretion over its use. </li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.3</strong>These funds are accounted for separately and not used for operating expenses. </li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.4</strong>SportsPik acts solely as an agent concerning the prize pool and does not receive any benefit or margin from this portion. </li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.5</strong>If a round is cancelled, the prize pool may be refunded or reallocated in line with published rules. </li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.6</strong>Mutual Contribution Agreement: By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement. SportsPik facilitates this payout on behalf of the players.</li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.7</strong>Clarification of Supply: The platform fee represents the consideration for SportsPik’s service. The prize pool portion is not linked to any deliverable, benefit, or service from SportsPik and should not be considered part of the platform’s taxable supply.</li>
                  </ul>
                </div>
                <p className="md:text-[20px] mt-[3%] text-[#0000005A] font-semibold italic"><strong className="text-[#000000] font-semibold">LAST UPDATED: 1 July 2025.</strong></p>

              </Card>
            </div>
          </div>

          <MobileFooter />
        </div>
      ) : isTab ? (
        <div className="overflow-auto bg-[url('../public/v2/images/bg/auth-bg.png')] bg-cover h-[100vh]">
          <div className="h-[100vh] w-full p-5 font-Inter">
            {!userInfo?.email && (
              <div className="flex w-full px-3 pb-5 items-center justify-between border-b border-[#D3D3D31F] w-[95%] mx-auto">
                <div className="flex-shrink-0">
                  <img 
                    src={pnpLogo} 
                    alt="pickNdPrizes" 
                    onClick={redirectHome}
                    className="h-20 cursor-pointer"
                  />
                </div>
                <div className="laptop-banner:text-[15px] text-[12px] font-[400] font-roboto flex laptop-banner:gap-5 gap-2 items-center flex-shrink-0">
                  <button
                    className="bg-[#00C05B] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[1rem] sm:px-[1.5rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToLogin}
                  >
                    Login
                  </button>

                  <button
                    className="bg-[#007FFF] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[0.75rem] sm:px-[1rem] md:px-[1.15rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToRegister}
                  >
                    Sign Up For Free
                  </button>
                </div>
              </div>
            )}

            {/* <div> */}
            <div className={`terms-top ${userInfo?.email ? 'mt-[2%]' : 'mt-10'}`}>
              <h2 className="text-[#FFFFFF] text-[48px] text-center font-interFont">
                Terms & Conditions
              </h2>
            </div>

            {/* <Card className="m-auto font-interFont h-[70vh] overflow-auto pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px]">
              <div className="text-[22px] text-[#000000] font-semibold">
                <h4>1. Introduction</h4>
                <h4>2. Acceptance of Terms</h4>
                <h4>3. Account Registration & Eligibility</h4>
                <h4>4. Entry Fees & Payments</h4>
                <h4>5. Account Termination, Closure & Suspension</h4>
                <h4>6. Game Entry, Announcements & Results</h4>
                <h4>7. Syndication</h4>
                <h4>8. Game Rules</h4>
                <h4>9. How to Win</h4>
                <h4>10. Responsible Gaming</h4>
                <h4>11. Taxes</h4>
                <h4>12. Use of Personal Information</h4>
                <h4>13. Intellectual Property</h4>
                <h4>14. General Conditions</h4>
                <h4>15. Governing Law & Jurisdiction</h4>
                <h4>16. Prize Pool & Fee Structure</h4>
              </div>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                1. Introduction
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                You can access the full Terms at: www.sportspik.com (the official 'website'). For any support, you may email support@sportspik.com. Operating Hours: 10 AM to 10 PM (GST), daily.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                2. Acceptance of Terms
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • These Terms
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Our Privacy Policy
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Our Cookies Policy
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Our Games Rules
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • You have the mental capacity to be responsible for your actions and can enter into a contract.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • You accept that winning is not guaranteed and tokens must be purchased to play.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                These Terms are posted on our website and are effective from 1st July 2025. We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                3. Account Registration & Eligibility
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • You must be at least 18 years of age to register.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • You must provide accurate personal details: full name, telephone number, and email address.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • We may request age and identity verification and use third-party services for verification checks.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                3.1 Sanctioned & Blocked Countries
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                4. Entry Fees & Payments
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                Each token purchased consists of two parts:
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                5. Account Termination, Closure & Suspension
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if you register more than one account, provide fraudulent information, enter games from restricted jurisdictions, or for maintenance purposes.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                6. Game Entry, Announcements & Results
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                Announcements are made via:
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Website: www.sportspik.com
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Social media: @SportsPik
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Email and push notifications
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                To enter a game, you must have an active account, purchase/redeem a minimum number of tokens required to play that round, and use token(s) to enter each round.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                7. Syndication
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. We will only be liable for any valid claim made by the registered holder of the account with the winning entry.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                8. Game Rules
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                By accepting these Terms, you agree to be bound by the SportsPik game rules.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Each round has a predetermined entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Each player can submit one or two independent picks per round. Some rounds like the high roller may be limited to one pick per player.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Each pick is assigned to a team per match week.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • A win advances the pick to the next week; a draw or a loss eliminates it.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • A team cannot be reused under the same pick until the round ends.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                8.1 Champions League
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Follows all SportsPik rules unless otherwise stated.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • First eight match weeks follow a league format; then knockout rounds begin.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Picks become limited to advancing 16 teams.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Game ends after the second leg of the quarterfinals.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                9. How to Win
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • The jackpot is won by the last remaining pick in the round.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • If all picks are eliminated in the same week, the prize is split.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                10. Responsible Gaming
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform. We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a Gaming Timeout by email at support@sportspik.com.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                11. Taxes
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Token prices include applicable taxes.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                12. Use of Personal Information
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Personal data (name, contact details, etc.) is collected for account and competition purposes.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • This data may be shared with regulatory or third-party partners.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • By registering, you consent to the use of your data as outlined in our Privacy Policy.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                13. Intellectual Property
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • Content is for personal, non-commercial use only.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                • You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                14. General Conditions
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                15. Governing Law & Jurisdiction
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the Ras Al Khaimah Economic Zone (RAKEZ) and the United Arab Emirates. By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts.
              </p>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                16. Prize Pool & Fee Structure
              </h4>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                Each token payment made by players is divided into two components:
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                a. Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT).
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                b. Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of participants, and not treated as income.
              </p>
              <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement.
              </p>

              <p className="text-[17px] mt-[2%] text-[#000000] font-semibold">
                LAST UPDATED: 1 July 2025
              </p>
            </Card> */}
            {/* <Card className="m-auto font-interFont h-[70vh] overflow-auto pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px]">
                <div className="text-[22px] text-[#000000] font-semibold">
                  <h4>1. Introduction</h4>
                  <h4>2. Acceptance of Terms</h4>
                  <h4>3. Account Registration & Eligibility</h4>
                  <h4>4. Entry Fees & Payments</h4>
                  <h4>5. Account Termination, Closure & Suspension</h4>
                  <h4>6. Game Entry, Announcements & Results</h4>
                  <h4>7. Syndication</h4>
                  <h4>8. Game Rules</h4>
                  <h4>9. How to Win</h4>
                  <h4>10. Responsible Gaming</h4>
                  <h4>11. Taxes</h4>
                  <h4>12. Use of Personal Information</h4>
                  <h4>13. Intellectual Property</h4>
                  <h4>14. General Conditions</h4>
                  <h4>15. Governing Law & Jurisdiction</h4>
                  <h4>16. Prize Pool & Fee Structure</h4>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  1. INTRODUCTION
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You can access the full Terms at: www.sportspik.com (the official 'website'). For any support, you may email support@sportspik.com. Operating Hours: 10 AM to 10 PM (GST), daily.
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  We encourage all participants to play responsibly. Participation should be for entertainment purposes only. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  2. ACCEPTANCE OF TERMS
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • These Terms
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Our Privacy Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Our Cookies Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Our Games Rules
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You have the mental capacity to be responsible for your actions and can enter into a contract.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You accept that winning is not guaranteed and tokens must be purchased to play.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms are posted on our website and are effective from 1st July 2025. We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You are responsible for reviewing the Terms and Rules each time you use our platform or app. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3. ACCOUNT REGISTRATION & ELIGIBILITY  
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You must be at least 18 years of age to register.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You must provide accurate personal details: full name, telephone number, and email address.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • We may request age and identity verification and use third-party services for verification checks.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3.1 SANCTIONED & BLOCKED COUNTRIES
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
                </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • We reserve the right to block, suspend, or terminate access from such jurisdictions without notice. 
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • It is your sole responsibility to ensure that using our services is legal in your jurisdiction. We accept no liability for use in contravention of local laws. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  4. ENTRY FEES & PAYMENTS 
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Each token purchased consists of two parts:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  • A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  The administrative fee is treated as revenue. The prize pool contribution is not income and is not subject to VAT, as SportsPik acts only in a custodial or agency capacity for this portion. 
                </p>

               <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">5. ACCOUNT TERMINATION, CLOSURE & SUSPENSION</h4>

<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>5.1</strong> We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>You register more than one account at any one time;</li>
      <li>You provided information that is fraudulent, false, incomplete, or not up to date;</li>
      <li>We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
      <li>Platform or app maintenance work or upgrades are required;</li>
      <li>For any reason, we discontinue the games, or platform access;</li>
      <li>Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>5.2</strong> In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>5.3</strong> We reserve the right to take one or more of the following actions if you breach these Terms or Rules:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Terminate, vary, or suspend your account, access to the Platform, or entry into games;</li>
      <li>Take legal proceedings against you for reimbursement of any and all relevant costs on an indemnity basis resulting from your breach;</li>
      <li>Take further legal action against you, as appropriate;</li>
      <li>Disclose such information to law enforcement authorities as required or as we deem necessary; and/or</li>
      <li>Any other actions which we deem appropriate (and lawful).</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>5.4</strong> We hereby exclude any and all liability arising out of any actions (including but not limited to those set out above) that we may take in response to breaches of these Terms and Rules.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>5.5</strong> If you wish to delete your account, you may do so via “My Account.” This will permanently remove your data and forfeits any unused entries.</p>
  </li>
</ul>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">6. GAME ENTRY, ANNOUNCEMENTS, & RESULTS</h4>

<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>Announcements are made via:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Website: <a href="https://www.sportspik.com">www.sportspik.com</a></li>
      <li>Social media: @SportsPik</li>
      <li>Email and push notifications</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>To enter a game, you must:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Have an active account</li>
      <li>Purchase/Redeem a minimum number of tokens required to play that round</li>
      <li>Use token(s) to enter each round</li>
    </ul>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><em>Note: Purchased tokens are non-refundable and cannot be withdrawn. Only cash prizes are eligible for withdrawal.</em></p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>Results:</strong> Winners and results will be posted on the website and may be shared via email or on social media. Players are responsible for checking and claiming winnings in time.</p>
  </li>
</ul>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">7. SYNDICATION</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. By entering Games, you acknowledge that no representation has been made by us that we shall be responsible for or have any liability whatsoever for any purported claim from a Syndicate Member. For the avoidance of doubt, we will only be liable for any valid claim made by the registered holder of the account with the winning entry. </p>
  </li>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong>7.1</strong> Where you enter with the intent of sharing a Prize with Syndicate Members, you:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Deemed to be the customer for the purposes of these Rules; and</li>
      <li>Are not acting as our agent for that purpose and we shall not be:
        <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
          <li>Liable for the payment of any Prize to any Syndicate Member other than a Prize emanating from a winning entry which is payable only to the registered holder of the Account with such winning entry; and </li>
          <li>Bound by any agreement between the registered holder of the Account and any Syndicate Member. </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">8. GAME RULES</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>By accepting these Terms, you agree to be bound by the SportsPik game rules.</li>
  <li>Each round has a set entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.</li>
  <li>Each player can submit one or two independent picks per round. Some rounds like the high roller may be limited to one pick per player.</li>
  <li>Each pick is assigned to a team per match week. </li>
  <li>A win advances the pick to the next week; a draw or a loss eliminates it.</li>
  <li>A team cannot be reused in the same pick until the round ends.</li>
  <li>If no pick is submitted before the deadline (1 hour before kickoff), a default team is assigned.</li>
  <li>One default allowed per pick per round. A second default leads to elimination.</li>
  <li>Picks are editable until the match week deadline.</li>
  <li>Postponed matches:
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Before deadline: must re-pick</li>
      <li>After deadline: treated as a win</li>
    </ul>
  </li>
  <li>For a "match week" to count or be valid in the competition, there must be at least 8 scheduled matches (fixtures) during that week. </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#0000005A] font-semibold">Disqualification:</h4>
  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>Entries are incomplete, offensive, fraudulent, or breach of laws</li>
  <li>Technical or verification checks are failed </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#0000005A] font-semibold">Game Cancellation: </h4>
  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We may cancel or suspend a game due to force majeure events like natural disasters, strikes, or health concerns. No liability is assumed. </p>


<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">8.1 CHAMPIONS LEAGUE:</p>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>Follows SportsPik rules unless otherwise noted.</li>
  <li>First 8 weeks follow league format; then knockout rounds begin.</li>
  <li>Picks are limited to remaining 16 teams during knockouts.</li>
  <li>Game ends after quarterfinals (second leg).</li>
  <li>Defaults during knockouts follow league rankings from week 8.</li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">9. HOW TO WIN</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>The jackpot is won by the last remaining pick in the round. </li>
  <li>If all picks are eliminated in the same week, the prize is split. </li>
  <li>When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.</li>
  <li>If there is no winner by the final week (last available match week), or if all the remaining players are eliminated at once, the jackpot will be equally split between those players. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">10. RESPONSIBLE GAMING</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li><strong>10.1</strong> You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform (website and mobile application). We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming. If you are struggling, we encourage you to seek help or email  <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a></li>
  <li><strong>10.2</strong> If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a Gaming Timeout by email at <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>  During this time:
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Your account will be locked and inaccessible for gameplay.</li>
      <li>No promotional will be sent.</li>
      <li>Tokens cannot be used until the timeout ends.</li>
     
    </ul>
  </li>
</ul>
 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">Once the requested period ends, your account will automatically be reactivated.</p>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">11. TAXES</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.</li>
  <li>Token prices include applicable taxes.</li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">12. USE OF PERSONAL INFORMATION</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>Personal data (name, contact details, etc.) is collected for account and competition purposes</li>
  <li>This data may be shared with regulatory or third-party partners.</li>
  <li>By registering, you consent to the use of your data as outlined in our Privacy Policy.</li>
  <li>You can access or update your information at any time. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">13. INTELLECTUAL PROPERTY</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors. </li>
  <li>Content is for personal, non-commercial use only</li>
  <li>You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">14. GENERAL CONDITIONS</h4>
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">   We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control. </p>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">15. GOVERNING LAW & JURISDICTION</h4>
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the Ras Al Khaimah Economic Zone (RAKEZ) and the United Arab Emirates. By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts. </p>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">16. PRIZE POOL & FEE STRUCTURE</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li><strong>16.1</strong> Each token payment made by players is divided into two components
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>a. Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT). </li>
      <li>b.  Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of participants, and not treated as income. </li>
    </ul>
  </li>
  <li><strong>16.2</strong> The prize pool is used strictly to fund player winnings as per the game rules. SportsPik has no discretion over its use. </li>
  <li><strong>16.3</strong> These funds are accounted for separately and not used for operating expenses. </li>
  <li><strong>16.4</strong> SportsPik acts solely as an agent concerning the prize pool and does not receive any benefit or margin from this portion. </li>
  <li><strong>16.5</strong> If a round is cancelled, the prize pool may be refunded or reallocated in line with published rules. </li>
  { <li><strong>16.6</strong>Mutual Contribution Agreement: By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement. SportsPik facilitates this payout on behalf of the players.</li> }
  { <li><strong>16.7</strong>Clarification of Supply: The platform fee represents the consideration for SportsPik’s service. The prize pool portion is not linked to any deliverable, benefit, or service from SportsPik and should not be considered part of the platform’s taxable supply.</li> }
</ul>
<p className="text-[20px] mt-[1%] text-[#0000005A] font-semibold">LAST UPDATED: 1 July 2025.</p>

              </Card> */}
            {/* <Card className="m-auto font-interFont h-[70vh] overflow-auto pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px]">
                 <h4 className="text-[#000000] font-semibold">INDEX</h4>
                <div className="text-[22px] text-[#000000] font-semibold">
                  <h4>1. Introduction</h4>
                  <h4>2. Acceptance of Terms</h4>
                  <h4>3. Account Registration & Eligibility <br/>&nbsp;&nbsp; 3.1 Sanctioned & Blocked Countries </h4>
                  <h4>4. Entry Fees & Payments</h4>
                  <h4>5. Account Termination, Closure & Suspension</h4>
                  <h4>6. Game Entry, Announcements & Results</h4>
                  <h4>7. Syndication</h4>
                  <h4>8. Game Rules <br/>&nbsp;&nbsp; 8.1 Champions League</h4>
                  <h4>9. How to Win</h4>
                  <h4>10. Responsible Gaming</h4>
                  <h4>11. Taxes</h4>
                  <h4>12. Use of Personal Information</h4>
                  <h4>13. Intellectual Property</h4>
                  <h4>14. General Conditions</h4>
                  <h4>15. Governing Law & Jurisdiction</h4>
                  <h4>16. Prize Pool & Fee Structure</h4>
                </div>
              <div className="pt-5">
                <h2 className="text-[#000000] text-[24px] text-left font-semibold">
                  Terms & Conditions
                </h2>
              </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  1. INTRODUCTION
                </h4>
                <div className="pl-5">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You can access the full Terms at: www.sportspik.com (the official 'website'). For any support, you may email support@sportspik.com. <strong className="text-[#000000] font-semibold">Operating Hours:</strong> 10 AM to 10 PM (GST), daily.
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  We encourage all participants to play responsibly. Participation should be for entertainment purposes only. 
                </p>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  2. ACCEPTANCE OF TERMS
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> These Terms
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> Our Privacy Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> Our Cookies Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> Our Games Rules
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> You have the mental capacity to be responsible for your actions and can enter into a contract.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> You accept that winning is not guaranteed and tokens must be purchased to play.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold">•</strong> You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms are posted on our website and are effective from <strong className="text-[#000000] font-semibold">1st July 2025.</strong> We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You are responsible for reviewing the Terms and Rules each time you use our platform or app. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3. ACCOUNT REGISTRATION & ELIGIBILITY  
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> You must be at least 18 years of age to register.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> You must provide accurate personal details: full name, telephone number, and email address.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> We may request age and identity verification and use third-party services for verification checks.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3.1 SANCTIONED & BLOCKED COUNTRIES
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
                </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> We reserve the right to block, suspend, or terminate access from such jurisdictions without notice. 
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> It is your sole responsibility to ensure that using our services is legal in your jurisdiction. We accept no liability for use in contravention of local laws. 
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  4. ENTRY FEES & PAYMENTS 
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4.1</strong>&nbsp;All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4.2</strong>&nbsp; Each token purchased consists of two parts:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">•</strong> A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  The administrative fee is treated as revenue. The prize pool contribution is not income and is not subject to VAT, as SportsPik acts only in a custodial or agency capacity for this portion. 
                </p>

               <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">5. ACCOUNT TERMINATION, CLOSURE & SUSPENSION</h4>

<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.1</strong> We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-6 space-y-1">
  <li className="relative pl-6 before:content-['a)'] before:absolute before:left-0 before:text-black">You register more than one account at any one time;</li>
  <li className="relative pl-6 before:content-['b)'] before:absolute before:left-0 before:text-black">You provided information that is fraudulent, false, incomplete, or not up to date;</li>
  <li className="relative pl-6 before:content-['c)'] before:absolute before:left-0 before:text-black">We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
  <li className="relative pl-6 before:content-['d)'] before:absolute before:left-0 before:text-black">Platform or app maintenance work or upgrades are required;</li>
  <li className="relative pl-6 before:content-['e)'] before:absolute before:left-0 before:text-black">For any reason, we discontinue the games, or platform access;</li>
  <li className="relative pl-6 before:content-['f)'] before:absolute before:left-0 before:text-black">Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
</ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.2</strong> In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.3</strong> We reserve the right to take one or more of the following actions if you breach these Terms or Rules:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Terminate, vary, or suspend your account, access to the Platform, or entry into games;</li>
      <li>Take legal proceedings against you for reimbursement of any and all relevant costs on an indemnity basis resulting from your breach;</li>
      <li>Take further legal action against you, as appropriate;</li>
      <li>Disclose such information to law enforcement authorities as required or as we deem necessary; and/or</li>
      <li>Any other actions which we deem appropriate (and lawful).</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.4</strong> We hereby exclude any and all liability arising out of any actions (including but not limited to those set out above) that we may take in response to breaches of these Terms and Rules.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.5</strong> If you wish to delete your account, you may do so via “My Account.” This will permanently remove your data and forfeits any unused entries.</p>
  </li>
</ul>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">6. GAME ENTRY, ANNOUNCEMENTS, & RESULTS</h4>

<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Announcements are made via:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Website: <a href="https://www.sportspik.com">www.sportspik.com</a></li>
      <li>Social media: @SportsPik</li>
      <li>Email and push notifications</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">To enter a game, you must:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Have an active account</li>
      <li>Purchase/Redeem a minimum number of tokens required to play that round</li>
      <li>Use token(s) to enter each round</li>
    </ul>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><em><strong className="text-[#000000] font-semibold">Note:</strong> Purchased tokens are non-refundable and cannot be withdrawn. Only cash prizes are eligible for withdrawal.</em></p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Results:</strong> Winners and results will be posted on the website and may be shared via email or on social media. Players are responsible for checking and claiming winnings in time.</p>
  </li>
</ul>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">7. SYNDICATION</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. By entering Games, you acknowledge that no representation has been made by us that we shall be responsible for or have any liability whatsoever for any purported claim from a Syndicate Member. For the avoidance of doubt, we will only be liable for any valid claim made by the registered holder of the account with the winning entry. </p>
  </li>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">7.1 Where you enter with the intent of sharing a Prize with Syndicate Members, you are:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li><strong className="text-[#000000] font-semibold">7.1.1</strong>&nbsp;Deemed to be the customer for the purposes of these Rules; and</li>
      <li><strong className="text-[#000000] font-semibold">7.1.2</strong>&nbsp;Are not acting as our agent for that purpose and we shall not be:
        <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
          <li>Liable for the payment of any Prize to any Syndicate Member other than a Prize emanating from a winning entry which is payable only to the registered holder of the Account with such winning entry; and </li>
          <li>Bound by any agreement between the registered holder of the Account and any Syndicate Member. </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">8. GAME RULES</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>By accepting these Terms, you agree to be bound by the SportsPik game rules.</li>
  <li>Each round has a set entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.</li>
  <li>Each player can submit <strong className="text-[#000000] font-semibold">one or two independent picks</strong> per round. Some rounds like the high roller may be limited to one pick per player.</li>
  <li><strong className="text-[#000000] font-semibold">Each pick</strong> is assigned to a team per match week. </li>
  <li>A win advances the pick to the next week; a draw or a loss eliminates it.</li>
  <li>A team cannot be reused in the same pick until the round ends.</li>
  <li>If no pick is submitted before the deadline (1 hour before kickoff), a default team is assigned.</li>
  <li>One default allowed per pick per round. A second default leads to elimination.</li>
  <li>Picks are editable until the match week deadline.</li>
  <li>Postponed matches:
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5 space-y-1">
  <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
    Before deadline: must re-pick
  </li>
  <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
    After deadline: treated as a win
  </li>
</ul>
  </li>
  <li>For a "match week" to count or be valid in the competition, there must be <strong className="text-[#000000] font-semibold">at least 8 scheduled matches</strong> (fixtures) during that week. </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Disqualification:</h4>
  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Entries are incomplete, offensive, fraudulent, or breach of laws</li>
  <li>Technical or verification checks are failed </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Game Cancellation: </h4>
  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We may cancel or suspend a game due to force majeure events like natural disasters, strikes, or health concerns. No liability is assumed. </p>


<p className="text-[17px] mt-[1%] text-[#000000] font-semibold">8.1 CHAMPIONS LEAGUE:</p>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Follows SportsPik rules unless otherwise noted.</li>
  <li>First eight match weeks follow league format; then knockout rounds begin.</li>
  <li>Picks become limited to advancing 16 teams.</li>
  <li>Game ends after the second leg of the quarterfinals.</li>
  <li>Defaults during knockouts follow league ranking from week 8.</li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">9. HOW TO WIN</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>The jackpot is won by the last remaining pick in the round. </li>
  <li>If all picks are eliminated in the same week, the prize is split. </li>
  <li>When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.</li>
  <li>If there is no winner by the final week (last available match week), or if all the remaining players are eliminated at once, the jackpot will be equally split between those players. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">10. RESPONSIBLE GAMING</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
  <li><strong className="text-[#000000] font-semibold">10.1</strong> You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform (website and mobile application). We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming. If you are struggling, we encourage you to seek help or email  <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a></li>
  <li><strong className="text-[#000000] font-semibold">10.2</strong> If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a <strong className="text-[#000000] font-semibold">Gaming Timeout</strong> by email at <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>  <strong className="text-[#000000] font-semibold">During this time:</strong>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Your account will be locked and inaccessible for gameplay.</li>
      <li>No promotional will be sent.</li>
      <li>Tokens cannot be used until the timeout ends.</li>
     
    </ul>
  </li>
</ul>
 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">Once the requested period ends, your account will automatically be reactivated.</p>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">11. TAXES</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.</li>
  <li>Token prices include applicable taxes.</li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">12. USE OF PERSONAL INFORMATION</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Personal data (name, contact details, etc.) is collected for account and competition purposes.</li>
  <li>This data may be shared with regulatory or third-party partners.</li>
  <li>By registering, you consent to the use of your data as outlined in our Privacy Policy.</li>
  <li>You can access or update your information at any time. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">13. INTELLECTUAL PROPERTY</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors. </li>
  <li>Content is for personal, non-commercial use only.</li>
  <li>You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners. </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">14. GENERAL CONDITIONS</h4>
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">   We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control. </p>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">15. GOVERNING LAW & JURISDICTION</h4>
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the  <strong className="text-[#000000] font-semibold">Ras Al Khaimah Economic Zone (RAKEZ)</strong> and the <strong className="text-[#000000] font-semibold">United Arab Emirates.</strong> By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts. </p>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">16. PRIZE POOL & FEE STRUCTURE</h4>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
  <li><strong className="text-[#000000] font-semibold">16.1</strong> Each token payment made by players is divided into two components:
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
      <li>a. Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT). </li>
      <li>b.  Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of <strong className="text-[#000000] font-semibold">participants, and not treated as income.</strong> </li>
    </ul>
  </li>
  <li><strong className="text-[#000000] font-semibold">16.2</strong> The prize pool is used strictly to fund player winnings as per the game rules. SportsPik has no discretion over its use. </li>
  <li><strong className="text-[#000000] font-semibold">16.3</strong> These funds are accounted for separately and not used for operating expenses. </li>
  <li><strong className="text-[#000000] font-semibold">16.4</strong> SportsPik acts solely as an agent concerning the prize pool and does not receive any benefit or margin from this portion. </li>
  <li><strong className="text-[#000000] font-semibold">16.5</strong> If a round is cancelled, the prize pool may be refunded or reallocated in line with published rules. </li>
  <li><strong className="text-[#000000] font-semibold">16.6</strong> Mutual Contribution Agreement: By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement. SportsPik facilitates this payout on behalf of the players.</li>
 <li><strong className="text-[#000000] font-semibold">16.7</strong> Clarification of Supply: The platform fee represents the consideration for SportsPik’s service. The prize pool portion is not linked to any deliverable, benefit, or service from SportsPik and should not be considered part of the platform’s taxable supply.</li>
</ul>
<p className="text-[20px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">LAST UPDATED: 1 July 2025.</strong></p>
              </Card> */}
            {/* <Card className="m-auto font-interFont h-[70vh] overflow-auto pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px]">
                 <h4 className="text-[22px] text-[#000000] font-semibold">INDEX</h4>
                
                <div className="text-[22px] text-[#000000] font-semibold space-y-2 pt-6">
  <h4 className="flex gap-2"><span className="w-6">1.</span> <span>Introduction</span></h4>
  <h4 className="flex gap-2"><span className="w-6">2.</span> <span>Acceptance of Terms</span></h4>
  <h4 className="flex flex-col gap-1">
    <div className="flex gap-2"><span className="w-6">3.</span> <span>Account Registration & Eligibility</span></div>
    <div className="pl-8">3.1 Sanctioned & Blocked Countries</div>
  </h4>
  <h4 className="flex gap-2"><span className="w-6">4.</span> <span>Entry Fees & Payments</span></h4>
  <h4 className="flex gap-2"><span className="w-6">5.</span> <span>Account Termination, Closure & Suspension</span></h4>
  <h4 className="flex gap-2"><span className="w-6">6.</span> <span>Game Entry, Announcements & Results</span></h4>
  <h4 className="flex gap-2"><span className="w-6">7.</span> <span>Syndication</span></h4>
  <h4 className="flex flex-col gap-1">
    <div className="flex gap-2"><span className="w-6">8.</span> <span>Game Rules</span></div>
    <div className="pl-8">8.1 Champions League</div>
  </h4>
  <h4 className="flex gap-2"><span className="w-6">9.</span> <span>How to Win</span></h4>
  <h4 className="flex gap-2"><span className="w-6">10.</span> <span>Responsible Gaming</span></h4>
  <h4 className="flex gap-2"><span className="w-6">11.</span> <span>Taxes</span></h4>
  <h4 className="flex gap-2"><span className="w-6">12.</span> <span>Use of Personal Information</span></h4>
  <h4 className="flex gap-2"><span className="w-6">13.</span> <span>Intellectual Property</span></h4>
  <h4 className="flex gap-2"><span className="w-6">14.</span> <span>General Conditions</span></h4>
  <h4 className="flex gap-2"><span className="w-6">15.</span> <span>Governing Law & Jurisdiction</span></h4>
  <h4 className="flex gap-2"><span className="w-6">16.</span> <span>Prize Pool & Fee Structure</span></h4>
</div>

              <div className="pt-16">
                <h2 className="text-[#000000] text-[24px] text-left font-semibold">
                  Terms & Conditions
                </h2>
              </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  1. INTRODUCTION
                </h4>
                <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You can access the full Terms at: <span className="underline text-[#0000005A]"> www.sportspik.com</span> (the official 'website'). For any support, you may email <span className="underline text-[#0000005A]"> support@sportspik.com</span>. <strong className="text-[#000000] font-semibold">Operating Hours:</strong> 10 AM to 10 PM (GST), daily.
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  We encourage all participants to play responsibly. Participation should be for entertainment purposes only. 
                </p>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  2. ACCEPTANCE OF TERMS
                </h4>
                <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> These Terms
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Privacy Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Cookies Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Games Rules
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> You have the mental capacity to be responsible for your actions and can enter into a contract.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> You accept that winning is not guaranteed and tokens must be purchased to play.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                   <strong className="text-[#000000] font-semibold pr-2">•</strong> You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms are posted on our website and are effective from <strong className="text-[#000000] font-semibold">1st July 2025.</strong> We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You are responsible for reviewing the Terms and Rules each time you use our platform or app. 
                </p>
                  </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3. ACCOUNT REGISTRATION & ELIGIBILITY  
                </h4>
                <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You must be at least 18 years of age to register.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You must provide accurate personal details: full name, telephone number, and email address.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> We may request age and identity verification and use third-party services for verification checks.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
                </p>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3.1 SANCTIONED & BLOCKED COUNTRIES
                </h4>
                <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
                </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> We reserve the right to block, suspend, or terminate access from such jurisdictions without notice. 
                </p>
                 <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> It is your sole responsibility to ensure that using our services is legal in your jurisdiction. We accept no liability for use in contravention of local laws. 
                </p>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  4. ENTRY FEES & PAYMENTS 
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4.1</strong>&nbsp;&nbsp;All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4.2</strong>&nbsp;&nbsp;Each token purchased consists of two parts:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-10">
                  <strong className="text-[#000000] font-semibold">•</strong> An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-10">
                  <strong className="text-[#000000] font-semibold">•</strong> A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold  pl-7">
                  The administrative fee is treated as revenue. The prize pool contribution is not income and is not subject to VAT, as SportsPik acts only in a custodial or agency capacity for this portion. 
                </p>

               <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">5. ACCOUNT TERMINATION, CLOSURE & SUSPENSION</h4>
<div className="pl-6">
<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold pr-2">5.1</strong> We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if:</p>
   
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-6 space-y-1">
  <li className="relative pl-6 before:content-['a)'] before:absolute before:left-0 before:text-black">You register more than one account at any one time;</li>
  <li className="relative pl-6 before:content-['b)'] before:absolute before:left-0 before:text-black">You provided information that is fraudulent, false, incomplete, or not up to date;</li>
  <li className="relative pl-6 before:content-['c)'] before:absolute before:left-0 before:text-black">We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
  <li className="relative pl-6 before:content-['d)'] before:absolute before:left-0 before:text-black">Platform or app maintenance work or upgrades are required;</li>
  <li className="relative pl-6 before:content-['e)'] before:absolute before:left-0 before:text-black">For any reason, we discontinue the games, or platform access;</li>
  <li className="relative pl-6 before:content-['f)'] before:absolute before:left-0 before:text-black">Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
</ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.2</strong> In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.3</strong> We reserve the right to take one or more of the following actions if you breach these Terms or Rules:</p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Terminate, vary, or suspend your account, access to the Platform, or entry into games;</li>
      <li>Take legal proceedings against you for reimbursement of any and all relevant costs on an indemnity basis resulting from your breach;</li>
      <li>Take further legal action against you, as appropriate;</li>
      <li>Disclose such information to law enforcement authorities as required or as we deem necessary; and/or</li>
      <li>Any other actions which we deem appropriate (and lawful).</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.4</strong> We hereby exclude any and all liability arising out of any actions (including but not limited to those set out above) that we may take in response to breaches of these Terms and Rules.</p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.5</strong> If you wish to delete your account, you may do so via “My Account.” This will permanently remove your data and forfeits any unused entries.</p>
  </li>
</ul>
</div>
<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">6. GAME ENTRY, ANNOUNCEMENTS, & RESULTS</h4>
<div className="pl-6">
<ul>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Announcements are made via:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Website: <a href="https://www.sportspik.com" class="underline">www.sportspik.com</a></li>
      <li>Social media: @SportsPik</li>
      <li>Email and push notifications</li>
    </ul>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">To enter a game, you must:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Have an active account</li>
      <li>Purchase/Redeem a minimum number of tokens required to play that round</li>
      <li>Use token(s) to enter each round</li>
    </ul>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><em><strong className="text-[#000000] font-semibold">Note:</strong> Purchased tokens are non-refundable and cannot be withdrawn. Only cash prizes are eligible for withdrawal.</em></p>
  </li>

  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Results:</strong> Winners and results will be posted on the website and may be shared via email or on social media. Players are responsible for checking and claiming winnings in time.</p>
  </li>
</ul>
</div>
<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">7. SYNDICATION</h4>
<ul className="text-[17px]  text-[#0000005A] font-semibold  pl-5">
  <li>
    <p className="text-[17px] pl-4 text-[#0000005A] font-semibold">We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. By entering Games, you acknowledge that no representation has been made by us that we shall be responsible for or have any liability whatsoever for any purported claim from a Syndicate Member. For the avoidance of doubt, we will only be liable for any valid claim made by the registered holder of the account with the winning entry. </p>
  </li>
  <li>
    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">7.1 Where you enter with the intent of sharing a Prize with Syndicate Members, you are:</strong></p>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
      <li><strong className="text-[#000000] font-semibold pr-1">7.1.1</strong>&nbsp;Deemed to be the customer for the purposes of these Rules; and</li>
      <li><strong className="text-[#000000] font-semibold pr-1">7.1.2</strong>&nbsp;Are not acting as our agent for that purpose and we shall not be:
        <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
          <li>Liable for the payment of any Prize to any Syndicate Member other than a Prize emanating from a winning entry which is payable only to the registered holder of the Account with such winning entry; and </li>
          <li>Bound by any agreement between the registered holder of the Account and any Syndicate Member. </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">8. GAME RULES</h4>
 <p className="text-[17px] pl-7 text-[#0000005A] font-semibold">By accepting these Terms, you agree to be bound by the SportsPik game rules.</p>
<div className="pl-8">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  
  <li>Each round has a predetermined entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.</li>
  <li>Each player can submit <strong className="text-[#000000] font-semibold">one or two independent picks</strong> per round. Some rounds like the high roller may be limited to one pick per player.</li>
  <li><strong className="text-[#000000] font-semibold">Each pick</strong> is assigned to a team per match week. </li>
  <li>A win advances the pick to the next week; a draw or a loss eliminates it.</li>
  <li>A team cannot be reused under the same pick until the round ends</li>
   <li>If no pick is submitted by the advertised deadline (1 hour before the first match), a default team is assigned. </li>
  <li>One default is allowed per pick per round; a second results in elimination.</li>
  <li>Picks can be edited until the match week deadline.</li>
  <li>Postponed matches:
    
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5 space-y-1">
  <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
    Before deadline: must re-pick
  </li>
  <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
    After deadline: treated as a win
  </li>
</ul>
  </li>
  <li>For a "match week" to count or be valid in the competition, there must be <strong className="text-[#000000] font-semibold">at least 8 scheduled matches</strong> (fixtures) during that week. </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Disqualification:</h4>
  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Entries are incomplete, offensive, fraudulent, or breach of laws</li>
  <li>Technical or verification checks are failed </li>
  </ul>
  <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Game Cancellation: </h4>
  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We may cancel or suspend a game due to force majeure events like natural disasters, strikes, or health concerns. No liability is assumed. </p>


<p className="text-[17px] mt-[1%] text-[#000000] font-semibold">8.1 CHAMPIONS LEAGUE:</p>
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Follows all SportsPik rules unless otherwise stated.</li>
  <li>First eight match weeks follow a league format; then knockout rounds begin.</li>
  <li>Picks become limited to advancing 16 teams.</li>
  <li>Game ends after the second leg of the quarterfinals.</li>
  <li>Defaults during knockouts follow league ranking from week 8.</li>
</ul>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">9. HOW TO WIN</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>The jackpot is won by the last remaining pick in the round. </li>
  <li>If all picks are eliminated in the same week, the prize is split. </li>
  <li>When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.</li>
  <li>If there is no winner by the final week (last available match week), or if all the remaining players are eliminated at once, the jackpot will be equally split between those players. </li>
</ul>
</div>


<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">10. RESPONSIBLE GAMING</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
  <li><strong className="text-[#000000] font-semibold">10.1</strong> You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform (website and mobile application). We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming. If you are struggling, we encourage you to seek help or email  <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a></li>
  <li><strong className="text-[#000000] font-semibold">10.2</strong> If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a <strong className="text-[#000000] font-semibold">Gaming Timeout</strong> by email at <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>  <strong className="text-[#000000] font-semibold">During this time:</strong>
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
      <li>Your account will be locked and inaccessible for gameplay.</li>
      <li>No promotional will be sent.</li>
      <li>Tokens cannot be used until the timeout ends.</li>
     
    </ul>
  </li>
</ul>
 <p className="text-[17px] mt-[1%] text-[#0000005A] pl-5 font-semibold">Once the requested period ends, your account will automatically be reactivated.</p>
</div>
<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">11. TAXES</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.</li>
  <li>Token prices include applicable taxes.</li>
</ul>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">12. USE OF PERSONAL INFORMATION</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>Personal data (name, contact details, etc.) is collected for account and competition purposes.</li>
  <li>This data may be shared with regulatory or third-party partners.</li>
  <li>By registering, you consent to the use of your data as outlined in our Privacy Policy.</li>
  <li>You can access or update your information at any time. </li>
</ul>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">13. INTELLECTUAL PROPERTY</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
  <li>All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors. </li>
  <li>Content is for personal, non-commercial use only.</li>
  <li>You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners. </li>
</ul>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">14. GENERAL CONDITIONS</h4>
<div className="pl-6">
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">   We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control. </p>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">15. GOVERNING LAW & JURISDICTION</h4>
<div className="pl-6">
<p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the  <strong className="text-[#000000] font-semibold">Ras Al Khaimah Economic Zone (RAKEZ)</strong> and the <strong className="text-[#000000] font-semibold">United Arab Emirates.</strong> By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts. </p>
</div>

<h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">16. PRIZE POOL & FEE STRUCTURE</h4>
<div className="pl-6">
<ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
  <li><strong className="text-[#000000] font-semibold ">16.1</strong> Each token payment made by players is divided into two components:
    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
      <li>a. Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT). </li>
      <li>b.  Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of <strong className="text-[#000000] font-semibold">participants, and not treated as income.</strong> </li>
    </ul>
  </li>
  <li><strong className="text-[#000000] font-semibold pr-1">16.2</strong>The prize pool is used strictly to fund player winnings as per the game rules. SportsPik has no discretion over its use. </li>
  <li><strong className="text-[#000000] font-semibold pr-1">16.3</strong>These funds are accounted for separately and not used for operating expenses. </li>
  <li><strong className="text-[#000000] font-semibold pr-1">16.4</strong>SportsPik acts solely as an agent concerning the prize pool and does not receive any benefit or margin from this portion. </li>
  <li><strong className="text-[#000000] font-semibold pr-1">16.5</strong>If a round is cancelled, the prize pool may be refunded or reallocated in line with published rules. </li>
  <li><strong className="text-[#000000] font-semibold pr-1">16.6</strong>Mutual Contribution Agreement: By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement. SportsPik facilitates this payout on behalf of the players.</li>
 <li><strong className="text-[#000000] font-semibold pr-1">16.7</strong>Clarification of Supply: The platform fee represents the consideration for SportsPik’s service. The prize pool portion is not linked to any deliverable, benefit, or service from SportsPik and should not be considered part of the platform’s taxable supply.</li>
</ul>
</div>
<p className="text-[20px] mt-[3%] text-[#0000005A] font-semibold italic"><strong className="text-[#000000] font-semibold">LAST UPDATED: 1 July 2025.</strong></p>
   
              </Card> */}
            <Card className="m-auto font-interFont h-[70vh] overflow-auto pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px]">
              <h4 className="text-[22px] text-[#000000] font-semibold">INDEX</h4>
              {/* <div className="text-[22px] text-[#000000] font-semibold">
                  <h4>1. Introduction</h4>
                  <h4>2. Acceptance of Terms</h4>
                  <h4>3. Account Registration & Eligibility <br/>&nbsp;&nbsp; 3.1 Sanctioned & Blocked Countries </h4>
                  <h4>4. Entry Fees & Payments</h4>
                  <h4>5. Account Termination, Closure & Suspension</h4>
                  <h4>6. Game Entry, Announcements & Results</h4>
                  <h4>7. Syndication</h4>
                  <h4>8. Game Rules <br/>&nbsp;&nbsp; 8.1 Champions League</h4>
                  <h4>9. How to Win</h4>
                  <h4>10. Responsible Gaming</h4>
                  <h4>11. Taxes</h4>
                  <h4>12. Use of Personal Information</h4>
                  <h4>13. Intellectual Property</h4>
                  <h4>14. General Conditions</h4>
                  <h4>15. Governing Law & Jurisdiction</h4>
                  <h4>16. Prize Pool & Fee Structure</h4>
                </div> */}
              <div className="text-[19px] text-[#000000] font-semibold space-y-2 pt-6">
                <h4 className="flex gap-2"><span className="w-7">1.</span> <span>Introduction</span></h4>
                <h4 className="flex gap-2"><span className="w-7">2.</span> <span>Acceptance of Terms</span></h4>
                <h4 className="flex flex-col gap-1">
                  <div className="flex gap-2"><span className="w-7">3.</span> <span>Account Registration & Eligibility</span></div>
                  <div className="pl-9">3.1 Sanctioned & Blocked Countries</div>
                </h4>
                <h4 className="flex gap-2"><span className="w-7">4.</span> <span>Entry Fees & Payments</span></h4>
                <h4 className="flex gap-2"><span className="w-7">5.</span> <span>Account Termination, Closure & Suspension</span></h4>
                <h4 className="flex gap-2"><span className="w-7">6.</span> <span>Game Entry, Announcements & Results</span></h4>
                <h4 className="flex gap-2"><span className="w-7">7.</span> <span>Syndication</span></h4>
                <h4 className="flex flex-col gap-1">
                  <div className="flex gap-2"><span className="w-7">8.</span> <span>Game Rules</span></div>
                  <div className="pl-9">8.1 Champions League</div>
                </h4>
                <h4 className="flex gap-2"><span className="w-7">9.</span> <span>How to Win</span></h4>
                <h4 className="flex gap-2"><span className="w-7">10.</span> <span>Responsible Gaming</span></h4>
                <h4 className="flex gap-2"><span className="w-7">11.</span> <span>Taxes</span></h4>
                <h4 className="flex gap-2"><span className="w-7">12.</span> <span>Use of Personal Information</span></h4>
                <h4 className="flex gap-2"><span className="w-7">13.</span> <span>Intellectual Property</span></h4>
                <h4 className="flex gap-2"><span className="w-7">14.</span> <span>General Conditions</span></h4>
                <h4 className="flex gap-2"><span className="w-7">15.</span> <span>Governing Law & Jurisdiction</span></h4>
                <h4 className="flex gap-2"><span className="w-7">16.</span> <span>Prize Pool & Fee Structure</span></h4>
              </div>

              <div className="pt-16">
                <h2 className="text-[#000000] text-[24px] text-left font-semibold">
                  Terms & Conditions
                </h2>
              </div>
              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                1. INTRODUCTION
              </h4>
              <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You can access the full Terms at: <span className="underline text-[#0000005A]"> www.sportspik.com</span> (the official 'website'). For any support, you may email <span className="underline text-[#0000005A]"> support@sportspik.com</span>. <strong className="text-[#000000] font-semibold">Operating Hours:</strong> 10 AM to 10 PM (GST), daily.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  We encourage all participants to play responsibly. Participation should be for entertainment purposes only.
                </p>
              </div>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                2. ACCEPTANCE OF TERMS
              </h4>
              <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> These Terms
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Privacy Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Cookies Policy
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Games Rules
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You have the mental capacity to be responsible for your actions and can enter into a contract.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You accept that winning is not guaranteed and tokens must be purchased to play.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms are posted on our website and are effective from <strong className="text-[#000000] font-semibold">1st July 2025.</strong> We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  You are responsible for reviewing the Terms and Rules each time you use our platform or app.
                </p>
              </div>
              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                3. ACCOUNT REGISTRATION & ELIGIBILITY
              </h4>
              <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You must be at least 18 years of age to register.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You must provide accurate personal details: full name, telephone number, and email address.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> We may request age and identity verification and use third-party services for verification checks.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
                </p>
              </div>
              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                3.1 SANCTIONED & BLOCKED COUNTRIES
              </h4>
              <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> We reserve the right to block, suspend, or terminate access from such jurisdictions without notice.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold pr-2">•</strong> It is your sole responsibility to ensure that using our services is legal in your jurisdiction. We accept no liability for use in contravention of local laws.
                </p>
              </div>
              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                4. ENTRY FEES & PAYMENTS
              </h4>
              <div className="pl-6">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4.1</strong>&nbsp;&nbsp;All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4.2</strong>&nbsp;&nbsp;Each token purchased consists of two parts:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-10">
                  <strong className="text-[#000000] font-semibold">•</strong> An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-10">
                  <strong className="text-[#000000] font-semibold">•</strong> A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold ">
                  The administrative fee is treated as revenue. The prize pool contribution is not income and is not subject to VAT, as SportsPik acts only in a custodial or agency capacity for this portion.
                </p>
              </div>
              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">5. ACCOUNT TERMINATION, CLOSURE & SUSPENSION</h4>
              <div className="pl-6">
                <ul>
                  <li>
                    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold pr-2">5.1</strong> We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if:</p>
                    {/* <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>You register more than one account at any one time;</li>
      <li>You provided information that is fraudulent, false, incomplete, or not up to date;</li>
      <li>We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
      <li>Platform or app maintenance work or upgrades are required;</li>
      <li>For any reason, we discontinue the games, or platform access;</li>
      <li>Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
    </ul> */}
                    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-6 space-y-1">
                      <li className="relative pl-6 before:content-['a)'] before:absolute before:left-0 before:text-black">You register more than one account at any one time;</li>
                      <li className="relative pl-6 before:content-['b)'] before:absolute before:left-0 before:text-black">You provided information that is fraudulent, false, incomplete, or not up to date;</li>
                      <li className="relative pl-6 before:content-['c)'] before:absolute before:left-0 before:text-black">We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
                      <li className="relative pl-6 before:content-['d)'] before:absolute before:left-0 before:text-black">Platform or app maintenance work or upgrades are required;</li>
                      <li className="relative pl-6 before:content-['e)'] before:absolute before:left-0 before:text-black">For any reason, we discontinue the games, or platform access;</li>
                      <li className="relative pl-6 before:content-['f)'] before:absolute before:left-0 before:text-black">Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
                    </ul>
                  </li>

                  <li>
                    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.2</strong> In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.</p>
                  </li>

                  <li>
                    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.3</strong> We reserve the right to take one or more of the following actions if you breach these Terms or Rules:</p>
                    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                      <li>Terminate, vary, or suspend your account, access to the Platform, or entry into games;</li>
                      <li>Take legal proceedings against you for reimbursement of any and all relevant costs on an indemnity basis resulting from your breach;</li>
                      <li>Take further legal action against you, as appropriate;</li>
                      <li>Disclose such information to law enforcement authorities as required or as we deem necessary; and/or</li>
                      <li>Any other actions which we deem appropriate (and lawful).</li>
                    </ul>
                  </li>

                  <li>
                    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.4</strong> We hereby exclude any and all liability arising out of any actions (including but not limited to those set out above) that we may take in response to breaches of these Terms and Rules.</p>
                  </li>

                  <li>
                    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.5</strong> If you wish to delete your account, you may do so via “My Account.” This will permanently remove your data and forfeits any unused entries.</p>
                  </li>
                </ul>
              </div>
              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">6. GAME ENTRY, ANNOUNCEMENTS, & RESULTS</h4>
              <div className="pl-6">
                <ul>
                  <li>
                    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Announcements are made via:</strong></p>
                    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                      <li>Website: <a href="https://www.sportspik.com" class="underline">www.sportspik.com</a></li>
                      <li>Social media: @SportsPik</li>
                      <li>Email and push notifications</li>
                    </ul>
                  </li>

                  <li>
                    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">To enter a game, you must:</strong></p>
                    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                      <li>Have an active account</li>
                      <li>Purchase/Redeem a minimum number of tokens required to play that round</li>
                      <li>Use token(s) to enter each round</li>
                    </ul>
                    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><em><strong className="text-[#000000] font-semibold">Note:</strong> Purchased tokens are non-refundable and cannot be withdrawn. Only cash prizes are eligible for withdrawal.</em></p>
                  </li>

                  <li>
                    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Results:</strong> Winners and results will be posted on the website and may be shared via email or on social media. Players are responsible for checking and claiming winnings in time.</p>
                  </li>
                </ul>
              </div>
              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">7. SYNDICATION</h4>
              <ul className="text-[17px]  text-[#0000005A] font-semibold  pl-5">
                <li>
                  <p className="text-[17px] text-[#0000005A] font-semibold">We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. By entering Games, you acknowledge that no representation has been made by us that we shall be responsible for or have any liability whatsoever for any purported claim from a Syndicate Member. For the avoidance of doubt, we will only be liable for any valid claim made by the registered holder of the account with the winning entry. </p>
                </li>
                <li>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">7.1 Where you enter with the intent of sharing a Prize with Syndicate Members, you are:</strong></p>
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <li><strong className="text-[#000000] font-semibold pr-1">7.1.1</strong>&nbsp;Deemed to be the customer for the purposes of these Rules; and</li>
                    <li><strong className="text-[#000000] font-semibold pr-1">7.1.2</strong>&nbsp;Are not acting as our agent for that purpose and we shall not be:
                      <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                        <li>Liable for the payment of any Prize to any Syndicate Member other than a Prize emanating from a winning entry which is payable only to the registered holder of the Account with such winning entry; and </li>
                        <li>Bound by any agreement between the registered holder of the Account and any Syndicate Member. </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>


              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">8. GAME RULES</h4>
              <p className="text-[17px] pl-7 text-[#0000005A] font-semibold">By accepting these Terms, you agree to be bound by the SportsPik game rules.</p>
              <div className="pl-8">
                <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                  {/* <li>By accepting these Terms, you agree to be bound by the SportsPik game rules.</li> */}
                  <li>Each round has a predetermined entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.</li>
                  <li>Each player can submit <strong className="text-[#000000] font-semibold">one or two independent picks</strong> per round. Some rounds like the high roller may be limited to one pick per player.</li>
                  <li><strong className="text-[#000000] font-semibold">Each pick</strong> is assigned to a team per match week. </li>
                  <li>A win advances the pick to the next week; a draw or a loss eliminates it.</li>
                  <li>A team cannot be reused under the same pick until the round ends</li>
                  <li>If no pick is submitted by the advertised deadline (1 hour before the first match), a default team is assigned. </li>
                  <li>One default is allowed per pick per round; a second results in elimination.</li>
                  <li>Picks can be edited until the match week deadline.</li>
                  <li>Postponed matches:
                    {/* <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Before deadline: must re-pick</li>
      <li>After deadline: treated as a win</li>
    </ul> */}
                    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5 space-y-1">
                      <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
                        Before deadline: must re-pick
                      </li>
                      <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
                        After deadline: treated as a win
                      </li>
                    </ul>
                  </li>
                  <li>For a "match week" to count or be valid in the competition, there must be <strong className="text-[#000000] font-semibold">at least 8 scheduled matches</strong> (fixtures) during that week. </li>
                </ul>
                <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Disqualification:</h4>
                <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                  <li>Entries are incomplete, offensive, fraudulent, or breach of laws</li>
                  <li>Technical or verification checks are failed </li>
                </ul>
                <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Game Cancellation: </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We may cancel or suspend a game due to force majeure events like natural disasters, strikes, or health concerns. No liability is assumed. </p>


                <p className="text-[17px] mt-[1%] text-[#000000] font-semibold">8.1 CHAMPIONS LEAGUE:</p>
                <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                  <li>Follows all SportsPik rules unless otherwise stated.</li>
                  <li>First eight match weeks follow a league format; then knockout rounds begin.</li>
                  <li>Picks become limited to advancing 16 teams.</li>
                  <li>Game ends after the second leg of the quarterfinals.</li>
                  <li>Defaults during knockouts follow league ranking from week 8.</li>
                </ul>
              </div>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">9. HOW TO WIN</h4>
              <div className="pl-6">
                <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                  <li>The jackpot is won by the last remaining pick in the round. </li>
                  <li>If all picks are eliminated in the same week, the prize is split. </li>
                  <li>When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.</li>
                  <li>If there is no winner by the final week (last available match week), or if all the remaining players are eliminated at once, the jackpot will be equally split between those players. </li>
                </ul>
              </div>


              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">10. RESPONSIBLE GAMING</h4>
              <div className="pl-6">
                <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-3">
                  <li><strong className="text-[#000000] font-semibold">10.1</strong> You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform (website and mobile application). We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming. If you are struggling, we encourage you to seek help or email  <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a></li>
                  <li><strong className="text-[#000000] font-semibold">10.2</strong> If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a <strong className="text-[#000000] font-semibold">Gaming Timeout</strong> by email at <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>  <strong className="text-[#000000] font-semibold">During this time:</strong>
                    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                      <li>Your account will be locked and inaccessible for gameplay.</li>
                      <li>No promotional will be sent.</li>
                      <li>Tokens cannot be used until the timeout ends.</li>

                    </ul>
                  </li>
                </ul>
                <p className="text-[17px] mt-[1%] text-[#0000005A] pl-5 font-semibold">Once the requested period ends, your account will automatically be reactivated.</p>
              </div>
              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">11. TAXES</h4>
              <div className="pl-8">
                <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                  <li>Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.</li>
                  <li>Token prices include applicable taxes.</li>
                </ul>
              </div>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">12. USE OF PERSONAL INFORMATION</h4>
              <div className="pl-9">
                <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                  <li>Personal data (name, contact details, etc.) is collected for account and competition purposes.</li>
                  <li>This data may be shared with regulatory or third-party partners.</li>
                  <li>By registering, you consent to the use of your data as outlined in our Privacy Policy.</li>
                  <li>You can access or update your information at any time. </li>
                </ul>
              </div>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">13. INTELLECTUAL PROPERTY</h4>
              <div className="pl-9">
                <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                  <li>All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors. </li>
                  <li>Content is for personal, non-commercial use only.</li>
                  <li>You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners. </li>
                </ul>
              </div>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">14. GENERAL CONDITIONS</h4>
              <div className="pl-9">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">   We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control. </p>
              </div>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">15. GOVERNING LAW & JURISDICTION</h4>
              <div className="pl-9">
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the  <strong className="text-[#000000] font-semibold">Ras Al Khaimah Economic Zone (RAKEZ)</strong> and the <strong className="text-[#000000] font-semibold">United Arab Emirates.</strong> By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts. </p>
              </div>

              <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">16. PRIZE POOL & FEE STRUCTURE</h4>
              <div className="pl-6">
                <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-3">
                  <li><strong className="text-[#000000] font-semibold ">16.1</strong> Each token payment made by players is divided into two components:
                    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
                      <li><strong className="text-[#000000] font-semibold ">a.</strong> Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT). </li>
                      <li><strong className="text-[#000000] font-semibold ">b.</strong>  Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of <strong className="text-[#000000] font-semibold">participants, and not treated as income.</strong> </li>
                    </ul>
                  </li>
                  <li><strong className="text-[#000000] font-semibold pr-1">16.2</strong>The prize pool is used strictly to fund player winnings as per the game rules. SportsPik has no discretion over its use. </li>
                  <li><strong className="text-[#000000] font-semibold pr-1">16.3</strong>These funds are accounted for separately and not used for operating expenses. </li>
                  <li><strong className="text-[#000000] font-semibold pr-1">16.4</strong>SportsPik acts solely as an agent concerning the prize pool and does not receive any benefit or margin from this portion. </li>
                  <li><strong className="text-[#000000] font-semibold pr-1">16.5</strong>If a round is cancelled, the prize pool may be refunded or reallocated in line with published rules. </li>
                  <li><strong className="text-[#000000] font-semibold pr-1">16.6</strong>Mutual Contribution Agreement: By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement. SportsPik facilitates this payout on behalf of the players.</li>
                  <li><strong className="text-[#000000] font-semibold pr-1">16.7</strong>Clarification of Supply: The platform fee represents the consideration for SportsPik’s service. The prize pool portion is not linked to any deliverable, benefit, or service from SportsPik and should not be considered part of the platform’s taxable supply.</li>
                </ul>
              </div>
              <p className="text-[20px] mt-[3%] text-[#0000005A] font-semibold italic"><strong className="text-[#000000] font-semibold">LAST UPDATED: 1 July 2025.</strong></p>

            </Card>

            {/* </div> */}
          </div>
          <FooterTab />
        </div>
      ) : (
        <div className="flex flex-col bg-[url('../public/v2/images/bg/auth-bg.png')] w-full bg-cover overflow-auto h-[100vh]">
          <div
            className=" flex-1 p-5 font-Inter"
          >
            {!userInfo?.email && (
              <div className="flex p-3 items-center justify-between border-b border-[#D3D3D31F] w-[95%] mx-auto">
                <div className="flex-shrink-0">
                  <img src={pnpLogo} alt="pickNdPrizes" onClick={redirectHome} className="h-20 cursor-pointer"></img>
                </div>
                <div className="laptop-banner:text-[15px] text-[12px] font-[400] font-roboto flex laptop-banner:gap-5 gap-2 items-center flex-shrink-0">
                  <button
                    className="bg-[#00C05B] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[1rem] sm:px-[1.5rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToLogin}
                  >
                    Login
                  </button>

                  <button
                    className="bg-[#007FFF] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[0.75rem] sm:px-[1rem] md:px-[1.15rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToRegister}
                  >
                    Sign Up For Free
                  </button>
                </div>
              </div>
            )}
            <div>
              <div className={`${userInfo?.email ? 'mt-12' : 'mt-10'}`}>
                <h2 className="text-[#FFFFFF] text-[48px] text-center">
                  Terms & Conditions
                </h2>
              </div>

              {/* <Card className="m-auto laptop-s:h-[600px] laptop-l:h-[70vh] desktop:h-[80vh] overflow-auto  pl-16 pt-12 pb-12 pr-16 flex flex-col justify-between w-[95%] my-[1%] bg-[#FFFFFF] shadow-md rounded-[12px] ">
                <div className="text-[22px] text-[#000000] font-semibold">
                  <h4>1. Introduction </h4>
                  <h4>2. Terms & Conditions</h4>
                  <h4>3. Eligibility & Registration</h4>
                  <h4>4. Game Announcement & Entry</h4>
                  <h4>5. Rules of Sportspik</h4>
                  <h4>6. How Sportspik is Won</h4>
                  <h4>7. Taxes</h4>
                  <h4>8. Use of Personal Information</h4>
                  <h4>9. Intellectual Property</h4>
                  <h4>10. General Conditions</h4>
                  <h4>11. Governing Law & Jurisdiction</h4>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  1.Introduction
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Sportspik (‘games’, or ‘MoneyBall’) are brought to you by
                  SureShotSports FZ-LLC ( ‘SSS’, ’the Company’, ‘we’, ‘us’ or
                  ‘our’).
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  SureShotSports FZ-LLC is a limited liability company
                  incorporated under the laws , rules and regulations of Ras Al
                  Khaimah Economic Zone Authority under trade license No.
                  17002810 with a registered office situated at FDAM0767 Compass
                  Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al
                  Khaimah, UAE.
                </p>

                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  These Terms and Conditions of Service (‘Terms and Conditions’,
                  ‘Terms’) lay out the Terms on which you are allowed to access
                  and play Sportspik products (games which are playable on
                  our website).
                </p>

                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Reference to ‘you’ or ‘your’ or ‘customer’ or ‘participant’ or
                  ‘player’ is reference to any person that uses the services of
                  SureShotSports FZ-LLC or any registered customer of SSS.
                </p>

                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  The Terms can be accessed via our website at
                  www.picksnprizes.com (the ‘website’)
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  2.Terms and Conditions
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  2.1 By registering on our website and taking part in any of
                  the games via the website/mobile application ‘App’ (including,
                  but not limited to sub domains and/or API’s ) you confirm that
                  you have read and are legally bound by:
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  (i) our Terms and Conditions of the games;
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  (ii) our Privacy Policy;
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  (iii) our Cookies Policy and
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  (iv) the rules of our games
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  (v) you have the mental capacity to take responsibility for
                  you own actions and decision making, and can enter into this
                  contract with us.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  (vi) you accept full responsibility for playing in these games
                  in the knowledge that winning is not guaranteed and tokens
                  have to be purchased with money to be able to play.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  (vii) You will not use this service in any way which could
                  cause offence, be considered defamatory, obscene, abusive,
                  unlawful, racist, sexist or in any way discriminatory to any
                  of SSS’s staff or other customers.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Please read these Terms carefully, and pay attention to all
                  the terms before registering with us and playing any of the
                  games on our website
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  2.2 These Terms are effective from 1st May 2024. SSS reserves
                  the right to amend, modify, and/or change the Terms at any
                  time for any number of reasons, including but not restricted
                  to comply with changes to applicable laws and regulations and
                  any other regulatory requirements. An up to date set of terms
                  and conditions will be available on our website and you are
                  advised to review the Terms on a frequent basis. If for any
                  reason any changes in Terms are not acceptable to you, then
                  you should close your account with us and cease using our
                  services. If you continue to use our service and participate
                  in any of the games on our website after the date that the
                  changes of the Terms come into effect then you will be deemed
                  to have accepted these changes and are happy to continue.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  2.3 It is your sole responsibility to review the Terms and
                  Conditions (including the Game Rules) and any amendments to
                  them each time you use the website and/or mobile Application.
                </p>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3. Eligibility & Registration
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  3.1 In order to participate in the games that SSS provide you
                  will need to register on our website. You must be at least
                  Twenty-One (21) years of age to be able to register.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  3.2 When registering, you will be required to provide personal
                  details such as, Your name, Date of birth, address, telephone
                  number and an email address. You warrant that all the personal
                  details you provide are accurate, correct and complete. If the
                  details are incomplete or inaccurate, we may suspend your
                  account. If any of your personal details change, please inform
                  us as soon as possible so that we may maintain accurate and up
                  to date records. You can change the details provided at
                  registration at any time by editing your profile after you log
                  in.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  3.3 The Company reserves the right, at any time, to request
                  verification of the age, identity, residential address, or any
                  other information relevant to participation in the
                  Competition/s of all participants. The Company reserves the
                  right to disqualify any participant who provides false
                  information or fails to provide information that is reasonably
                  requested by the Company.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  3.4 A customer is only permitted to have one account to use
                  our service and the personal details that are provided will be
                  confirmed through verification checks. We may use third-party
                  companies to carry out these checks on the company’s behalf.
                  This process involves checking the details that you disclose
                  against certain databases, both public and private. By
                  entering this process you agree that we may use, record and
                  disclose such personal information, and that the data may be
                  recorded by us or the third party company.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Customers may not have more than one Account. If we have
                  reason to believe two or more accounts are held by the same
                  person, they will be deemed ‘Duplicate Accounts’. The Account
                  most recently registered will be closed. If any winnings have
                  been obtained via a duplicate account SureShotSports FZ-LLC
                  reserves the right to withhold these winnings.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  3.5 All transactions where your username and password have
                  been entered correctly will be regarded as valid, whether or
                  not authorized by you, and we shall not be liable for any
                  claims in the event that you disclose them to anyone. It is
                  your sole responsibility to maintain the confidentiality of
                  your password and you are responsible for all activity that
                  occurs under your username and password. You should notify us
                  of any unauthorized use of your password and any breach of
                  security as soon as you become aware of it.
                </p>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  4. Games Announcement & Entry
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  4.1 The Company or SSS announces that new games or rounds are
                  available via any of the following:
                </p>
                <div className="flex mt-[1%] gap-2">
                  <p className="text-[17px] text-[#0000005A] font-semibold">
                    (i) Our website{" "}
                    <a
                      href="http://www.picksnprizes.com"
                      alt="picksnprizes"
                      className="text-[#4f779b]"
                      style={{ textDecoration: "underline" }}
                    >
                      www.picksnprizes.com
                    </a>
                  </p>
                </div>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  (ii) The Company’s account on social media platforms
                  “Facebook”, “Instagram”, “Twitter”, “Tik Tok”
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  (iii) Emails
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  4.2 Customers can play in any game or round once their account
                  is active by the use of Tokens. Tokens can be purchased on the
                  website and each round will have a specified number of Tokens
                  to enter.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  4.3 Any purchased tokens will not be available for withdrawal
                  at any point and must be used towards playing the game. Only
                  winnings can be withdrawn.
                </p>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  5. Rules of Sportspik (the game)
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.1 By accepting the Terms and Conditions, you agree to the
                  Competition Rules, and it will be legally binding on you.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.2 The rules of Sportspik are the same for all Sportspik
                  games.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.3 The entry fee and the prize money for each round of
                  Sportspik are pre-determined before the start of the round.
                  The aggregate of all the entry fees in a particular round
                  minus a 10% administrative fee will make up the prize money or
                  the jackpot of that round.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.4 Using each account a participant can join any Sportspik
                  round with one or two picks. Two is the maximum per
                  participant in a single round.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.5 If a participant is playing with two picks each pick is
                  treated completely independently in terms of playing the game.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.6 The participant shall join any round (active/open round)
                  of the competition up until the deadline of that round. The
                  deadline of each round and each match week within the round is
                  set at 1 hour prior to the commencement of the first match in
                  that match week.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.7 The objective of the game is to assign each of your picks
                  to a team in that week’s fixture list who the participant
                  thinks they win their match. If the selected team wins their
                  match that pick progresses to the following match week. If the
                  selected team draws or loses their match then that pick is
                  eliminated.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Example: Pick 1: Arsenal, and Pick 2: Liverpool. Arsenal draw
                  and Liverpool win then Pick 1 is eliminated and Pick 2
                  progresses.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  If your pick is successful then you progress to the following
                  week and must repeat the process.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.8 Once a team is picked it cannot be chosen again under the
                  same pick until the round is over.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Example: Since Pick 2 above selected Liverpool and they won
                  their match, then that player can no longer choose Liverpool
                  under Pick 2 for the rest of the round.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.9 Once again, and as indicated in point 5.4 above, if a
                  participant is playing in a round with two picks then they are
                  treated independently.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Using the same example in point 6 above, let’s assume both
                  Arsenal & Liverpool have won their respective matches, in that
                  case Pick 1 will no longer be able to choose Arsenal again
                  until the round is over, however Pick 2 can still use Arsenal
                  since it hasn’t been used before.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Consequently, since the two entries are treated independently
                  a player can pick the same team for both their picks as long
                  as he hasn’t used them previously in the same round.
                </p>

                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.10 If a pick is not submitted before the deadline, that pick
                  will automatically be assigned to the lowest ranked team in
                  the league table that is available for that pick. If a
                  participant is playing with two picks and misses the deadline
                  on both, then one pick will be assigned to the lowest ranked
                  team available from the league table while the second pick
                  will be assigned to the second to last available team.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  Example: Sheffield and Burnley are ranked 20th and 19th in the
                  Premier League coming into the match week. A participant who
                  is playing with two picks misses the deadline. In that case,
                  Pick 1 will automatically select Sheffield while Pick 2 will
                  automatically select Burnley. Let’s assume that participant
                  had already picked Burnley under Pick 2 in a prior match week
                  within that same round. In that case Pick 2 will automatically
                  select the 18th ranked team in the table and so on.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.11 Each pick is only allowed one default per round. The
                  second default within the same round will result in automatic
                  elimination.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.12 Once a pick is made it can be changed up till the
                  deadline of that match week.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.13 If a match is postponed prior to the deadline lapsing the
                  player must re-pick by choosing a team from the remaining
                  fixtures that match week. If the match is postponed after the
                  deadline has passed then any picks for that fixture will be
                  deemed successful and the players involved will not be allowed
                  to pick those same teams again in that round.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.14 Any matches played out of the normal schedule or that
                  were previously postponed will not be part of the fixtures to
                  select from and will be ignored.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.15 A match week will only be considered for selection if it
                  has a minimum of 8 fixtures. Match weeks that have less will
                  be skipped in the schedule.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.16 The Company reserves the right, in its sole discretion,
                  to refuse to accept participation that is incomplete,
                  indecipherable, offensive, does not comply with these T&Cs, or
                  contravenes any applicable laws or regulation.
                </p>
                <p className="text-[17px]  mt-[1%] text-[#0000005A] font-semibold">
                  5.17 The Company reserves the right, in its sole discretion,
                  to disqualify any participant's account who has breached any
                  of these T&Cs, has engaged in unlawful or improper conduct or
                  otherwise acts to cheat or undermine the fairness of the
                  Competition/s by, for example, tampering with, or using or
                  exploiting errors in, the participation process to obtain a
                  competitive advantage over other entrants.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.18 SureShotSports FZ-LLC, if necessary to do so, reserve the
                  right to suspend, amend, void or even cancel a game. This may
                  be necessary for reasons beyond our reasonable control
                  including, but not limited to strike, labour dispute, illness,
                  act of God, natural disaster, adverse weather conditions, war,
                  riot, accident, public health concern in relation to potential
                  infection, epidemic or pandemic, malicious damage, fire, flood
                  and/or storm, compliance with law or governmental order, rule,
                  regulation or direction, breakdown of plant, machinery or
                  transportation. SSS are not responsible for any loss or damage
                  caused to you as a result of any of these occurrences.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  5.19 The eligibility to participate is solely at the
                  discretion of the Company and we reserve the right to block or
                  not accept any registration.
                </p>
                <p className="text-[17px] mt-[1%]  text-[#0000005A] font-semibold">
                  5.20 The Company assumes no responsibility for any failure to
                  receive participation or for inaccurate information or any
                  loss, damage, or injury because of technical or
                  telecommunications problems, including security breaches. If
                  such problems arise, the Company may (where necessary with the
                  approval of the relevant authority) modify, cancel, terminate,
                  or suspend the Competition/s.
                </p>

                <p className="text-[17px] mt-[1%]  text-[#0000005A] font-semibold">
                  5.21 Sportspik Champions League
                </p>

                <p className="text-[17px] ml-[1%] mt-[1%]  text-[#0000005A] font-semibold">
                5.21.1 With the exception of the below deviations, all other rules from traditional Sportspik apply.
                </p>

                <p className="text-[17px] ml-[1%] mt-[1%]  text-[#0000005A] font-semibold">
                  5.21.2 Unlike normal league based Sportspik competitions, the
                  Champions League version of Sportspik will be initially based
                  on a league system. After the first round of 8 match weeks the
                  game will be based on a knock-out system.
                </p>

                <p className="text-[17px] ml-[1%] mt-[1%]  text-[#0000005A] font-semibold">
                  5.21.3 During the first eight match weeks players will be able
                  to make their selections among the 36 clubs involved.
                </p>

                <p className="text-[17px] ml-[1%] mt-[1%]  text-[#0000005A] font-semibold">
                  5.21.4 After match week eight, match week 9 & 10 will be the
                  two legs of the play-off which will be between the teams who
                  finished 9th -24th in the table. This means that your
                  selections will be restricted to those 16 teams.
                </p>

                <p className="text-[17px] ml-[1%] mt-[1%]  text-[#0000005A] font-semibold">
                  5.21.5 Match week 11 and beyond will be based on the 16 teams
                  that have qualified to the round of 16. These will include the
                  8 top teams after match week 8 in addition to the 8 teams
                  qualified from match week 9 & 10 play-off.
                </p>

                <p className="text-[17px] ml-[1%] mt-[1%]  text-[#0000005A] font-semibold">
                  5.21.6 Regardless of how many picks remain alive the game ends
                  after the second leg of the quarter-finals. The semi-finals
                  and final will not be included in the game.
                </p>

                <p className="text-[17px] ml-[1%] mt-[1%]  text-[#0000005A] font-semibold">
                  5.21.7 Each leg of each play-off & knock out stage will be
                  considered a separate match week. For example leg 1 of the
                  round of 16 is one match week while leg 2 is another.
                </p>

                <p className="text-[17px] ml-[1%] mt-[1%]  text-[#0000005A] font-semibold">
                  5.21.8 Should we have more than one pick remaining after the
                  second leg of the quarter final the jackpot will be
                  distributed equally among the remaining picks
                </p>

                <p className="text-[17px] ml-[1%] mt-[1%]  text-[#0000005A] font-semibold">
                  5.21.9 There could be a situation where players are still
                  alive at the quarter final stage and have no teams to pick
                  from. For Example, the 8 teams who qualified to the quarter
                  final had already been selected in prior match weeks by the
                  player. In this case when a player has no teams available to
                  pick from he/she will be automatically eliminated. Accordingly
                  players must be very careful in making their selections early
                  so as to ensure they have options during the quarter finals.
                </p>

                <p className="text-[17px] ml-[1%] mt-[1%]  text-[#0000005A] font-semibold">
                  5.21.10 Defaults at every stage will be based on the table
                  ranking in the first 8 match weeks. During the play-off &
                  knock-out a default will be assigned based on the lowest rank
                  team playing in these round as per the ranking after match
                  week 8.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  6. How Sportspik (the game) is Won
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  6.1 The game is won by the participant(s) who outlasts
                  everyone else. If we have one pick remaining after a match
                  week then that pick is the sole winner of the jackpot
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  6.2 If all the players remaining are all eliminated at the
                  same time then the jackpot is split equally amongst them.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  6.3 Once the number of picks remaining in a round is down to 5
                  picks or less a vote is automatically triggered on whether the
                  participants would like to equally share the prize among them
                  or continue playing.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  6.4 A split vote is successful only if it is unanimous,
                  otherwise we play on! If the vote is in favour of playing on,
                  the split/play on vote keeps getting triggered at the end of
                  each match week thereafter until we have a winner or a split
                  decision.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  6.5 When the game has gone to the maximum number of weeks
                  without a winner then the jackpot is split equally among the
                  remaining players. Maximum number of weeks is dependent on how
                  many teams are playing in that league.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  For example, for a league with 20 teams the maximum number of
                  weeks we can play without a winner is 20. For a league with 18
                  teams then the maximum number of weeks we can play is 18.
                </p>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  7. Taxes
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  7.1 If prizes are subject to any local tax law it is directly
                  deducted from the prize value.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  7.2 The amount paid towards purchasing token package are
                  inclusive of any local applicable taxes.
                </p>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  8. Use of Personal Information
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  8.1 Personal information including the eligible Participant’s
                  name, address, telephone number, and email will be collected
                  and used to conduct the Competitions. This may require
                  disclosure to third parties, including local regulatory
                  authorities and the Company’s agents or third-party service
                  providers, to conduct the Competition/s, or for promotional
                  and marketing purposes (including direct marketing). By
                  registering on our website the customer consents to the use of
                  their personal information.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  8.2 The participant may access, edit and/or update his
                  personal information under the privacy policy of the Company.
                </p>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  9. Intellectual Property
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  9.1 Players and participants acknowledge and agree that all
                  copyright, trademarks and any other intellectual property
                  rights contained in any material or any content supplied
                  (including any software) by us via the website or the mobile
                  application to you shall at all times remain vested in us or
                  our licensors. These intellectual property rights include,
                  without limitation, the design, graphics, layout, look and
                  feel and structure of our website, database rights, design
                  rights, domain names and rights to goodwill and/or to sue for
                  passing off. You are permitted to use this material and
                  content only as expressly authorized by us or our licensors.
                </p>

                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  9.2 By entering the Competition(s), participants agree to deal
                  with their entry content in any way that may otherwise
                  infringe the participants' moral rights and thus participants
                  agree to waive their claim of their moral rights (wherever
                  such rights are recognized) against the Company or its
                  assigns, licensees, or successors.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  9.3 Players/participants acknowledge and agree that the
                  material and content contained within our website and/or
                  mobile application are utilized in the provision of the
                  Services is made available by us to you for your own personal
                  non-commercial use only. Any other use of such material and
                  content is strictly prohibited. You agree not to (and agree
                  not to assist or facilitate any third party to) copy,
                  reproduce, transmit, publish, display, distribute,
                  commercially exploit, tamper with or create derivative works
                  of such material and content.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  9.4 The names, images and logos identifying us, our partners
                  or other third parties and our/their products and services
                  contained on our website and or mobile application are
                  proprietary marks and may not be reproduced or otherwise used
                  without our consent.
                </p>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  10. General Conditions
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  10.1 If for any reason beyond the reasonable control of the
                  Company the competition or game is not capable of running as
                  planned, the Company reserves the right in its sole discretion
                  to take any action that may be available to it, and to cancel,
                  terminate, modify, postpone, or suspend the competition(s) or
                  game(s), unless to do so would be prohibited by law.
                </p>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  10.2 The Company reserves the right to cancel, terminate,
                  modify, postpone, or suspend the Competition/s or amend these
                  terms and conditions, subject to any directions from a
                  regulatory authority.
                </p>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  11. Governing Law and Jurisdiction
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  11.1 The games on our website and any dispute or claim arising
                  out of or in connection with it or its subject matter or
                  formation shall be governed by and construed under the law,
                  rules and regulations of Ras Al Khaimah Economic Zone
                  Authority and the participant irrevocably agrees that the UAE
                  courts shall have exclusive jurisdiction to settle any dispute
                  or claim that arises out of or in connection with the
                  Competition/s or its subject matter or formation.
                </p>
              </Card> */}
              <Card className="m-auto laptop-s:h-[600px] laptop-l:h-[70vh] desktop:h-[80vh] overflow-auto pl-16 pt-12 pb-12 pr-16 flex flex-col justify-between w-[95%] my-[1%] bg-[#FFFFFF] shadow-md rounded-[12px]">
                <h4 className="text-[22px] text-[#000000] font-semibold">INDEX</h4>
                {/* <div className="text-[22px] text-[#000000] font-semibold">
                  <h4>1. Introduction</h4>
                  <h4>2. Acceptance of Terms</h4>
                  <h4>3. Account Registration & Eligibility <br/>&nbsp;&nbsp; 3.1 Sanctioned & Blocked Countries </h4>
                  <h4>4. Entry Fees & Payments</h4>
                  <h4>5. Account Termination, Closure & Suspension</h4>
                  <h4>6. Game Entry, Announcements & Results</h4>
                  <h4>7. Syndication</h4>
                  <h4>8. Game Rules <br/>&nbsp;&nbsp; 8.1 Champions League</h4>
                  <h4>9. How to Win</h4>
                  <h4>10. Responsible Gaming</h4>
                  <h4>11. Taxes</h4>
                  <h4>12. Use of Personal Information</h4>
                  <h4>13. Intellectual Property</h4>
                  <h4>14. General Conditions</h4>
                  <h4>15. Governing Law & Jurisdiction</h4>
                  <h4>16. Prize Pool & Fee Structure</h4>
                </div> */}
                <div className="text-[19px] text-[#000000] font-semibold space-y-2 pt-6">
                  <h4 className="flex gap-2"><span className="w-7">1.</span> <span>Introduction</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">2.</span> <span>Acceptance of Terms</span></h4>
                  <h4 className="flex flex-col gap-1">
                    <div className="flex gap-2"><span className="w-7">3.</span> <span>Account Registration & Eligibility</span></div>
                    <div className="pl-9">3.1 Sanctioned & Blocked Countries</div>
                  </h4>
                  <h4 className="flex gap-2"><span className="w-7">4.</span> <span>Entry Fees & Payments</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">5.</span> <span>Account Termination, Closure & Suspension</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">6.</span> <span>Game Entry, Announcements & Results</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">7.</span> <span>Syndication</span></h4>
                  <h4 className="flex flex-col gap-1">
                    <div className="flex gap-2"><span className="w-7">8.</span> <span>Game Rules</span></div>
                    <div className="pl-9">8.1 Champions League</div>
                  </h4>
                  <h4 className="flex gap-2"><span className="w-7">9.</span> <span>How to Win</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">10.</span> <span>Responsible Gaming</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">11.</span> <span>Taxes</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">12.</span> <span>Use of Personal Information</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">13.</span> <span>Intellectual Property</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">14.</span> <span>General Conditions</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">15.</span> <span>Governing Law & Jurisdiction</span></h4>
                  <h4 className="flex gap-2"><span className="w-7">16.</span> <span>Prize Pool & Fee Structure</span></h4>
                </div>

                <div className="pt-16">
                  <h2 className="text-[#000000] text-[24px] text-left font-semibold">
                    Terms & Conditions
                  </h2>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  1. INTRODUCTION
                </h4>
                <div className="pl-6">
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    SportsPik ("the games") is brought to you by SureShotSports FZ-LLC ("SSS", "the Company", "we", "us" or "our").
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    SureShotSports FZ-LLC is a limited liability company incorporated under the laws and regulations of the Ras Al Khaimah Economic Zone (RAKEZ) under Trade License No. 17002810. Our registered office is located at FDAM0767 Compass Building, Al Shohada Road, Al Hamra Industrial Zone, Ras Al Khaimah, UAE.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    These Terms and Conditions ("Terms") govern your access to and participation in all SportsPik products (games) on our website and mobile application.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    References to "you," "your," "customer," "participant," or "player" refer to any user of our services.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    You can access the full Terms at: <span className="underline text-[#0000005A]"> www.sportspik.com</span> (the official 'website'). For any support, you may email <span className="underline text-[#0000005A]"> support@sportspik.com</span>. <strong className="text-[#000000] font-semibold">Operating Hours:</strong> 10 AM to 10 PM (GST), daily.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    We encourage all participants to play responsibly. Participation should be for entertainment purposes only.
                  </p>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  2. ACCEPTANCE OF TERMS
                </h4>
                <div className="pl-6">
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    By registering on our website or mobile app when available (including any subdomains or APIs), you confirm that you have read, understood, and agreed to:
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> These Terms
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Privacy Policy
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Cookies Policy
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> Our Games Rules
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You have the mental capacity to be responsible for your actions and can enter into a contract.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You accept that winning is not guaranteed and tokens must be purchased to play.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You will not use the service in an offensive, defamatory, abusive, racist, sexist, or unlawful manner.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    These Terms are posted on our website and are effective from <strong className="text-[#000000] font-semibold">1st July 2025.</strong> We reserve the right to amend or update them at any time. Continued use of our services indicates acceptance of any changes.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    You are responsible for reviewing the Terms and Rules each time you use our platform or app.
                  </p>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3. ACCOUNT REGISTRATION & ELIGIBILITY
                </h4>
                <div className="pl-6">
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You must be at least 18 years of age to register.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You must provide accurate personal details: full name, telephone number, and email address.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> We may request age and identity verification and use third-party services for verification checks.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> Only one account per person is allowed. Duplicate accounts will be closed and winnings may be withheld.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You are responsible for maintaining the confidentiality of your login details. All activity under your account is your responsibility.
                  </p>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  3.1 SANCTIONED & BLOCKED COUNTRIES
                </h4>
                <div className="pl-6">
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> Access to our platform and participation in games is not permitted from countries or regions that are subject to sanctions, trade restrictions, or other prohibitions under international law, or by relevant regulatory authorities.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> You must not attempt to access the platform or create an account if you are located in or are a citizen of any country or region subject to such restrictions.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> We reserve the right to block, suspend, or terminate access from such jurisdictions without notice.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold pr-2">•</strong> It is your sole responsibility to ensure that using our services is legal in your jurisdiction. We accept no liability for use in contravention of local laws.
                  </p>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">
                  4. ENTRY FEES & PAYMENTS
                </h4>
                <div className="pl-6">
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold">4.1</strong>&nbsp;&nbsp;All token purchases and financial transactions on SportsPik are processed through secure third-party payment providers like MBME. By using our platform, you agree to their involvement in handling your transactions.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                    <strong className="text-[#000000] font-semibold">4.2</strong>&nbsp;&nbsp;Each token purchased consists of two parts:
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-10">
                    <strong className="text-[#000000] font-semibold">•</strong> An administrative fee, retained by SportsPik as consideration for providing access to the game platform (inclusive of VAT); and
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-10">
                    <strong className="text-[#000000] font-semibold">•</strong> A prize pool contribution, which is held on behalf of all participants and used solely to fund the prize payouts according to the game rules.
                  </p>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold ">
                    The administrative fee is treated as revenue. The prize pool contribution is not income and is not subject to VAT, as SportsPik acts only in a custodial or agency capacity for this portion.
                  </p>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">5. ACCOUNT TERMINATION, CLOSURE & SUSPENSION</h4>
                <div className="pl-6">
                  <ul>
                    <li>
                      <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold pr-2">5.1</strong> We may, at our sole discretion, terminate or suspend your account and access to the Platform without prior notice if:</p>
                      {/* <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>You register more than one account at any one time;</li>
      <li>You provided information that is fraudulent, false, incomplete, or not up to date;</li>
      <li>We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
      <li>Platform or app maintenance work or upgrades are required;</li>
      <li>For any reason, we discontinue the games, or platform access;</li>
      <li>Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
    </ul> */}
                      <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-6 space-y-1">
                        <li className="relative pl-6 before:content-['a)'] before:absolute before:left-0 before:text-black">You register more than one account at any one time;</li>
                        <li className="relative pl-6 before:content-['b)'] before:absolute before:left-0 before:text-black">You provided information that is fraudulent, false, incomplete, or not up to date;</li>
                        <li className="relative pl-6 before:content-['c)'] before:absolute before:left-0 before:text-black">We discover that you have entered games while physically located in a restricted jurisdiction (refer to section 3.1);</li>
                        <li className="relative pl-6 before:content-['d)'] before:absolute before:left-0 before:text-black">Platform or app maintenance work or upgrades are required;</li>
                        <li className="relative pl-6 before:content-['e)'] before:absolute before:left-0 before:text-black">For any reason, we discontinue the games, or platform access;</li>
                        <li className="relative pl-6 before:content-['f)'] before:absolute before:left-0 before:text-black">Your account has remained dormant for more than 12 months. We reserve the right to reclaim unclaimed balances or winnings, subject to applicable laws.</li>
                      </ul>
                    </li>

                    <li>
                      <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.2</strong> In the event that we terminate your account, you will lose all unutilized tokens and winnings will be forfeited.</p>
                    </li>

                    <li>
                      <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.3</strong> We reserve the right to take one or more of the following actions if you breach these Terms or Rules:</p>
                      <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                        <li>Terminate, vary, or suspend your account, access to the Platform, or entry into games;</li>
                        <li>Take legal proceedings against you for reimbursement of any and all relevant costs on an indemnity basis resulting from your breach;</li>
                        <li>Take further legal action against you, as appropriate;</li>
                        <li>Disclose such information to law enforcement authorities as required or as we deem necessary; and/or</li>
                        <li>Any other actions which we deem appropriate (and lawful).</li>
                      </ul>
                    </li>

                    <li>
                      <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.4</strong> We hereby exclude any and all liability arising out of any actions (including but not limited to those set out above) that we may take in response to breaches of these Terms and Rules.</p>
                    </li>

                    <li>
                      <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">5.5</strong> If you wish to delete your account, you may do so via “My Account.” This will permanently remove your data and forfeits any unused entries.</p>
                    </li>
                  </ul>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">6. GAME ENTRY, ANNOUNCEMENTS, & RESULTS</h4>
                <div className="pl-6">
                  <ul>
                    <li>
                      <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Announcements are made via:</strong></p>
                      <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                        <li>Website: <a href="https://www.sportspik.com" class="underline">www.sportspik.com</a></li>
                        <li>Social media: @SportsPik</li>
                        <li>Email and push notifications</li>
                      </ul>
                    </li>

                    <li>
                      <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">To enter a game, you must:</strong></p>
                      <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                        <li>Have an active account</li>
                        <li>Purchase/Redeem a minimum number of tokens required to play that round</li>
                        <li>Use token(s) to enter each round</li>
                      </ul>
                      <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><em><strong className="text-[#000000] font-semibold">Note:</strong> Purchased tokens are non-refundable and cannot be withdrawn. Only cash prizes are eligible for withdrawal.</em></p>
                    </li>

                    <li>
                      <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">Results:</strong> Winners and results will be posted on the website and may be shared via email or on social media. Players are responsible for checking and claiming winnings in time.</p>
                    </li>
                  </ul>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">7. SYNDICATION</h4>
                <ul className="text-[17px]  text-[#0000005A] font-semibold  pl-5">
                  <li>
                    <p className="text-[17px] text-[#0000005A] font-semibold">We disclaim any and all liability, including any express or implied warranties, whether oral or written to any Syndicate Members. By entering Games, you acknowledge that no representation has been made by us that we shall be responsible for or have any liability whatsoever for any purported claim from a Syndicate Member. For the avoidance of doubt, we will only be liable for any valid claim made by the registered holder of the account with the winning entry. </p>
                  </li>
                  <li>
                    <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold"><strong className="text-[#000000] font-semibold">7.1 Where you enter with the intent of sharing a Prize with Syndicate Members, you are:</strong></p>
                    <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                      <li><strong className="text-[#000000] font-semibold pr-1">7.1.1</strong>&nbsp;Deemed to be the customer for the purposes of these Rules; and</li>
                      <li><strong className="text-[#000000] font-semibold pr-1">7.1.2</strong>&nbsp;Are not acting as our agent for that purpose and we shall not be:
                        <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                          <li>Liable for the payment of any Prize to any Syndicate Member other than a Prize emanating from a winning entry which is payable only to the registered holder of the Account with such winning entry; and </li>
                          <li>Bound by any agreement between the registered holder of the Account and any Syndicate Member. </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>


                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">8. GAME RULES</h4>
                <p className="text-[17px] pl-7 text-[#0000005A] font-semibold">By accepting these Terms, you agree to be bound by the SportsPik game rules.</p>
                <div className="pl-8">
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    {/* <li>By accepting these Terms, you agree to be bound by the SportsPik game rules.</li> */}
                    <li>Each round has a predetermined entry fee per pick. The size of the jackpot will depend on the total number of picks joining that round, after deducting the administrative fee from the pool.</li>
                    <li>Each player can submit <strong className="text-[#000000] font-semibold">one or two independent picks</strong> per round. Some rounds like the high roller may be limited to one pick per player.</li>
                    <li><strong className="text-[#000000] font-semibold">Each pick</strong> is assigned to a team per match week. </li>
                    <li>A win advances the pick to the next week; a draw or a loss eliminates it.</li>
                    <li>A team cannot be reused under the same pick until the round ends</li>
                    <li>If no pick is submitted by the advertised deadline (1 hour before the first match), a default team is assigned. </li>
                    <li>One default is allowed per pick per round; a second results in elimination.</li>
                    <li>Picks can be edited until the match week deadline.</li>
                    <li>Postponed matches:
                      {/* <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5">
      <li>Before deadline: must re-pick</li>
      <li>After deadline: treated as a win</li>
    </ul> */}
                      <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5 space-y-1">
                        <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
                          Before deadline: must re-pick
                        </li>
                        <li className="relative pl-6 before:content-['✔'] before:absolute before:left-0 before:text-black before:text-sm">
                          After deadline: treated as a win
                        </li>
                      </ul>
                    </li>
                    <li>For a "match week" to count or be valid in the competition, there must be <strong className="text-[#000000] font-semibold">at least 8 scheduled matches</strong> (fixtures) during that week. </li>
                  </ul>
                  <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Disqualification:</h4>
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>Entries are incomplete, offensive, fraudulent, or breach of laws</li>
                    <li>Technical or verification checks are failed </li>
                  </ul>
                  <h4 className="text-[16px] mt-[2%] text-[#000000] font-semibold">Game Cancellation: </h4>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">We may cancel or suspend a game due to force majeure events like natural disasters, strikes, or health concerns. No liability is assumed. </p>


                  <p className="text-[17px] mt-[1%] text-[#000000] font-semibold">8.1 CHAMPIONS LEAGUE & EUROPA LEAGUE:</p>
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>Follows all SportsPik rules unless otherwise stated.</li>
                    <li>First eight match weeks follow a league format; then knockout rounds begin.</li>
                    <li>Picks become limited to advancing 16 teams.</li>
                    <li>Game ends after the second leg of the quarterfinals.</li>
                    <li>Defaults during knockouts follow league ranking from week 8.</li>
                  </ul>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">9. HOW TO WIN</h4>
                <div className="pl-6">
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>The jackpot is won by the last remaining pick in the round. </li>
                    <li>If all picks are eliminated in the same week, the prize is split. </li>
                    <li>When five or fewer picks remain, a unanimous vote can end the round in an equal prize split.</li>
                    <li>If there is no winner by the final week (last available match week), or if all the remaining players are eliminated at once, the jackpot will be equally split between those players. </li>
                  </ul>
                </div>


                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">10. RESPONSIBLE GAMING</h4>
                <div className="pl-6">
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-3">
                    <li><strong className="text-[#000000] font-semibold">10.1</strong> You are responsible for any entries, purchases, and losses incurred through your use of the SportsPik platform (website and mobile application). We take responsible gaming seriously and may suspend your account if we detect signs of problem gaming. If you are struggling, we encourage you to seek help or email  <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a></li>
                    <li><strong className="text-[#000000] font-semibold">10.2</strong> If you wish to take a short break (up to a maximum of 42 days) from participating in SportsPik games, you may request a <strong className="text-[#000000] font-semibold">Gaming Timeout</strong> by email at <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>  <strong className="text-[#000000] font-semibold">During this time:</strong>
                      <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                        <li>Your account will be locked and inaccessible for gameplay.</li>
                        <li>No promotional will be sent.</li>
                        <li>Tokens cannot be used until the timeout ends.</li>

                      </ul>
                    </li>
                  </ul>
                  <p className="text-[17px] mt-[1%] text-[#0000005A] pl-5 font-semibold">Once the requested period ends, your account will automatically be reactivated.</p>
                </div>
                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">11. TAXES</h4>
                <div className="pl-8">
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>Prizes may be subject to local tax laws, which are the responsibility of the player. Any applicable taxes will be deducted in accordance with the law.</li>
                    <li>Token prices include applicable taxes.</li>
                  </ul>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">12. USE OF PERSONAL INFORMATION</h4>
                <div className="pl-9">
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>Personal data (name, contact details, etc.) is collected for account and competition purposes.</li>
                    <li>This data may be shared with regulatory or third-party partners.</li>
                    <li>By registering, you consent to the use of your data as outlined in our Privacy Policy.</li>
                    <li>You can access or update your information at any time. </li>
                  </ul>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">13. INTELLECTUAL PROPERTY</h4>
                <div className="pl-9">
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold list-disc pl-5 marker:text-black">
                    <li>All content and materials (website, app, graphics, logos, structure) remain the property of SSS or its licensors. </li>
                    <li>Content is for personal, non-commercial use only.</li>
                    <li>You may not copy, publish, exploit, or tamper with our intellectual property related to us or our partners. </li>
                  </ul>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">14. GENERAL CONDITIONS</h4>
                <div className="pl-9">
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">   We reserve the right to modify, postpone, or cancel games or competitions if required by law or due to unforeseen circumstances beyond our control. </p>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">15. GOVERNING LAW & JURISDICTION</h4>
                <div className="pl-9">
                  <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">These Terms and Conditions, and any related dispute or claim, whether contractual or non-contractual, shall be governed by the laws of the  <strong className="text-[#000000] font-semibold">Ras Al Khaimah Economic Zone (RAKEZ)</strong> and the <strong className="text-[#000000] font-semibold">United Arab Emirates.</strong> By using the SportsPik platform or app when available, you agree to the exclusive jurisdiction of the UAE courts. </p>
                </div>

                <h4 className="text-[22px] mt-[2%] text-[#000000] font-semibold">16. PRIZE POOL & FEE STRUCTURE</h4>
                <div className="pl-6">
                  <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-3">
                    <li><strong className="text-[#000000] font-semibold ">16.1</strong> Each token payment made by players is divided into two components:
                      <ul className="text-[17px] mt-[1%] text-[#0000005A] font-semibold pl-5">
                        <li><strong className="text-[#000000] font-semibold ">a.</strong> Platform Fee: A fixed amount retained by SportsPik as an administrative fee (including VAT). </li>
                        <li><strong className="text-[#000000] font-semibold ">b.</strong>  Prize Pool Contribution: The remaining portion is allocated to a collective prize fund, held in trust or on behalf of <strong className="text-[#000000] font-semibold">participants, and not treated as income.</strong> </li>
                      </ul>
                    </li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.2</strong>The prize pool is used strictly to fund player winnings as per the game rules. SportsPik has no discretion over its use. </li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.3</strong>These funds are accounted for separately and not used for operating expenses. </li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.4</strong>SportsPik acts solely as an agent concerning the prize pool and does not receive any benefit or margin from this portion. </li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.5</strong>If a round is cancelled, the prize pool may be refunded or reallocated in line with published rules. </li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.6</strong>Mutual Contribution Agreement: By purchasing a token, the player agrees that their prize pool contribution is pooled with others and will be distributed to winners. All participants mutually agree with this arrangement. SportsPik facilitates this payout on behalf of the players.</li>
                    <li><strong className="text-[#000000] font-semibold pr-1">16.7</strong>Clarification of Supply: The platform fee represents the consideration for SportsPik’s service. The prize pool portion is not linked to any deliverable, benefit, or service from SportsPik and should not be considered part of the platform’s taxable supply.</li>
                  </ul>
                </div>
                <p className="text-[20px] mt-[3%] text-[#0000005A] font-semibold italic"><strong className="text-[#000000] font-semibold">LAST UPDATED: 1 July 2025.</strong></p>

              </Card>
            </div>
          </div>
          <>
            {/* For small devices */}
            <MobileFooter />

            {/* For tablet */}
            <FooterTab componnent="rules" />

            {/* For laptop and larger */}
            <Footer componnent="rules" />
          </>
        </div>
      )}
    </>
  );
}

export default TermsAndConditions;
